import f$1, { createContext, useState, useContext, useEffect, useReducer, useCallback, useRef, forwardRef, useMemo } from 'react';
import styled, { createGlobalStyle, ThemeProvider } from 'styled-components';
import { Route, Redirect } from 'react-router-dom';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;

var isAsyncMode = function (a) {
  return A(a) || z(a) === l;
};

var isConcurrentMode = A;

var isContextConsumer = function (a) {
  return z(a) === k;
};

var isContextProvider = function (a) {
  return z(a) === h;
};

var isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};

var isForwardRef = function (a) {
  return z(a) === n;
};

var isFragment = function (a) {
  return z(a) === e;
};

var isLazy = function (a) {
  return z(a) === t;
};

var isMemo = function (a) {
  return z(a) === r;
};

var isPortal = function (a) {
  return z(a) === d;
};

var isProfiler = function (a) {
  return z(a) === g;
};

var isStrictMode = function (a) {
  return z(a) === f;
};

var isSuspense = function (a) {
  return z(a) === p;
};

var isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};

var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var reactIs_development = createCommonjsModule(function (module, exports) {

  if (process.env.NODE_ENV !== "production") {
    (function () {
      // nor polyfill, then a plain number is used for performance.

      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});

var reactIs = createCommonjsModule(function (module) {

  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function () {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$1 = function (text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function () {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function (text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (!checker) {
          continue;
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from
      // props.


      var allKeys = objectAssign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = typeof propValue;

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;

  function getShim() {
    return shim;
  }
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var propTypes = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs; // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod

    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
});

var Variant = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SUCCESS: "success",
  WARNING: "warning",
  DANGER: "danger",
  INFO: "info",
  ALERT: "alert",
  SYSTEM: "system",
  DARK: "dark",
  LIGHT: "light"
};
var defaultColorScheme = {
  "primary": {
    "normal": "#0099ff",
    "light": "#ccebff",
    "dark": "#004c80",
    "color": "white"
  },
  "secondary": {
    "normal": "#F49717",
    "light": "#fbd8a9",
    "dark": "#F26D02",
    "color": "white"
  },
  "success": {
    "normal": "#0F9960",
    "light": "#53eeae",
    "dark": "#0a6b43",
    "color": "white"
  },
  "warning": {
    "normal": "#EB7E10",
    "light": "#f8ca9c",
    "dark": "#bb640d",
    "color": "white"
  },
  "danger": {
    "normal": "#db3737",
    "light": "#eea3a3",
    "dark": "#a71e1e",
    "color": "white"
  },
  "info": {
    "normal": "#137cbd",
    "light": "#bde2f8",
    "dark": "#0c4e77",
    "color": "white"
  },
  "alert": {
    "normal": "#5642a6",
    "light": "#c0b8e3",
    "dark": "#3a2c6f",
    "color": "white"
  },
  "system": {
    "normal": "#008075",
    "light": "#e6fffd",
    "dark": "#004d46",
    "color": "white"
  },
  "dark": {
    "normal": "#2e323f",
    "light": "#3C4152",
    "dark": "#2B2F3B",
    "color": "white"
  },
  "light": {
    "normal": "#e1e8ed",
    "light": "#f1f4f7",
    "dark": "#b1c3d0",
    "color": "black"
  }
};
function color(variant) {
  return defaultColorScheme[variant];
}

var size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px'
};
var Device = {
  MOBILE_S: "(min-width: ".concat(size.mobileS, ")"),
  MOBILE_M: "(min-width: ".concat(size.mobileM, ")"),
  MOBILE_L: "(min-width: ".concat(size.mobileL, ")"),
  TABLET: "(min-width: ".concat(size.tablet, ")"),
  LAPTOP: "(min-width: ".concat(size.laptop, ")"),
  LAPTOP_L: "(min-width: ".concat(size.laptopL, ")"),
  DESKTOP: "(min-width: ".concat(size.desktop, ")"),
  DESKTOP_L: "(min-width: ".concat(size.desktop, ")")
};

function level(n) {
  switch (n) {
    case 1:
      return "4";

    case 2:
      return "8";

    case 3:
      return "16";

    case 4:
      return "32";

    case 5:
      return "64";

    default:
      return "0";
  }
}
function space(n) {
  return level(n) + "px";
}

/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var reactJsxRuntime_production_min = createCommonjsModule(function (module, exports) {

  var g = 60103;
  exports.Fragment = 60107;

  if ("function" === typeof Symbol && Symbol.for) {
    var h = Symbol.for;
    g = h("react.element");
    exports.Fragment = h("react.fragment");
  }

  var m = f$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
      n = Object.prototype.hasOwnProperty,
      p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };

  function q(c, a, k) {
    var b,
        d = {},
        e = null,
        l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);

    for (b in a) n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);

    if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
    return {
      $$typeof: g,
      type: c,
      key: e,
      ref: l,
      props: d,
      _owner: m.current
    };
  }

  exports.jsx = q;
  exports.jsxs = q;
});

/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var reactJsxRuntime_development = createCommonjsModule(function (module, exports) {

  if (process.env.NODE_ENV !== "production") {
    (function () {

      var React = f$1;
      var _assign = objectAssign; // ATTENTION
      // When adding new symbols to this file,
      // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.

      var REACT_ELEMENT_TYPE = 0xeac7;
      var REACT_PORTAL_TYPE = 0xeaca;
      exports.Fragment = 0xeacb;
      var REACT_STRICT_MODE_TYPE = 0xeacc;
      var REACT_PROFILER_TYPE = 0xead2;
      var REACT_PROVIDER_TYPE = 0xeacd;
      var REACT_CONTEXT_TYPE = 0xeace;
      var REACT_FORWARD_REF_TYPE = 0xead0;
      var REACT_SUSPENSE_TYPE = 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = 0xead8;
      var REACT_MEMO_TYPE = 0xead3;
      var REACT_LAZY_TYPE = 0xead4;
      var REACT_BLOCK_TYPE = 0xead9;
      var REACT_SERVER_BLOCK_TYPE = 0xeada;
      var REACT_FUNDAMENTAL_TYPE = 0xead5;
      var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
      var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

      if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor('react.element');
        REACT_PORTAL_TYPE = symbolFor('react.portal');
        exports.Fragment = symbolFor('react.fragment');
        REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
        REACT_PROFILER_TYPE = symbolFor('react.profiler');
        REACT_PROVIDER_TYPE = symbolFor('react.provider');
        REACT_CONTEXT_TYPE = symbolFor('react.context');
        REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
        REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
        REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
        REACT_MEMO_TYPE = symbolFor('react.memo');
        REACT_LAZY_TYPE = symbolFor('react.lazy');
        REACT_BLOCK_TYPE = symbolFor('react.block');
        REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
        REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
        symbolFor('react.scope');
        symbolFor('react.opaque.id');
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
        symbolFor('react.offscreen');
        REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
      }

      var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = '@@iterator';

      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') {
          return null;
        }

        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

        if (typeof maybeIterator === 'function') {
          return maybeIterator;
        }

        return null;
      }

      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

      function error(format) {
        {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          printWarning('error', format, args);
        }
      }

      function printWarning(level, format, args) {
        // When changing this logic, you might want to also
        // update consoleWithStackDev.www.js as well.
        {
          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame.getStackAddendum();

          if (stack !== '') {
            format += '%s';
            args = args.concat([stack]);
          }

          var argsWithFormat = args.map(function (item) {
            return '' + item;
          }); // Careful: RN currently depends on this prefix

          argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
          // breaks IE9: https://github.com/facebook/react/issues/13610
          // eslint-disable-next-line react-internal/no-production-logging

          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      } // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.


      var enableScopeAPI = false; // Experimental Create Event Handle API.

      function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') {
          return true;
        } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


        if (type === exports.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
          return true;
        }

        if (typeof type === 'object' && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
            return true;
          }
        }

        return false;
      }

      function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
      }

      function getContextName(type) {
        return type.displayName || 'Context';
      }

      function getComponentName(type) {
        if (type == null) {
          // Host root, text node or just invalid type.
          return null;
        }

        {
          if (typeof type.tag === 'number') {
            error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
          }
        }

        if (typeof type === 'function') {
          return type.displayName || type.name || null;
        }

        if (typeof type === 'string') {
          return type;
        }

        switch (type) {
          case exports.Fragment:
            return 'Fragment';

          case REACT_PORTAL_TYPE:
            return 'Portal';

          case REACT_PROFILER_TYPE:
            return 'Profiler';

          case REACT_STRICT_MODE_TYPE:
            return 'StrictMode';

          case REACT_SUSPENSE_TYPE:
            return 'Suspense';

          case REACT_SUSPENSE_LIST_TYPE:
            return 'SuspenseList';
        }

        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + '.Consumer';

            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + '.Provider';

            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, 'ForwardRef');

            case REACT_MEMO_TYPE:
              return getComponentName(type.type);

            case REACT_BLOCK_TYPE:
              return getComponentName(type._render);

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  return getComponentName(init(payload));
                } catch (x) {
                  return null;
                }
              }
          }
        }

        return null;
      } // Helpers to patch console.logs to avoid logging during side-effect free
      // replaying on render function. This currently only patches the object
      // lazily which won't cover if the log function was extracted eagerly.
      // We could also eagerly patch the method.


      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;

      function disabledLog() {}

      disabledLog.__reactDisabledLog = true;

      function disableLogs() {
        {
          if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            }; // $FlowFixMe Flow thinks console is immutable.

            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
            /* eslint-enable react-internal/no-production-logging */
          }

          disabledDepth++;
        }
      }

      function reenableLogs() {
        {
          disabledDepth--;

          if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            }; // $FlowFixMe Flow thinks console is immutable.

            Object.defineProperties(console, {
              log: _assign({}, props, {
                value: prevLog
              }),
              info: _assign({}, props, {
                value: prevInfo
              }),
              warn: _assign({}, props, {
                value: prevWarn
              }),
              error: _assign({}, props, {
                value: prevError
              }),
              group: _assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: _assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: _assign({}, props, {
                value: prevGroupEnd
              })
            });
            /* eslint-enable react-internal/no-production-logging */
          }

          if (disabledDepth < 0) {
            error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
          }
        }
      }

      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;

      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === undefined) {
            // Extract the VM specific prefix used by each line.
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || '';
            }
          } // We use the prefix to ensure our stacks line up with native stack frames.


          return '\n' + prefix + name;
        }
      }

      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }

      function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) {
          return '';
        }

        {
          var frame = componentFrameCache.get(fn);

          if (frame !== undefined) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
          // for warnings.

          ReactCurrentDispatcher.current = null;
          disableLogs();
        }

        try {
          // This should throw.
          if (construct) {
            // Something should be setting the props in the constructor.
            var Fake = function () {
              throw Error();
            }; // $FlowFixMe


            Object.defineProperty(Fake.prototype, 'props', {
              set: function () {
                // We use a throwing setter instead of frozen or non-writable props
                // because that won't throw in a non-strict mode function.
                throw Error();
              }
            });

            if (typeof Reflect === 'object' && Reflect.construct) {
              // We construct a different control for this case to include any extra
              // frames added by the construct call.
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }

              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }

              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }

            fn();
          }
        } catch (sample) {
          // This is inlined manually because closure doesn't do it for us.
          if (sample && control && typeof sample.stack === 'string') {
            // This extracts the first frame from the sample that isn't also in the control.
            // Skipping one frame that we assume is the frame that calls the two.
            var sampleLines = sample.stack.split('\n');
            var controlLines = control.stack.split('\n');
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;

            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              // We expect at least one stack frame to be shared.
              // Typically this will be the root most one. However, stack frames may be
              // cut off due to maximum stack limits. In this case, one maybe cut off
              // earlier than the other. We assume that the sample is longer or the same
              // and there for cut off earlier. So we should find the root most frame in
              // the sample somewhere in the control.
              c--;
            }

            for (; s >= 1 && c >= 0; s--, c--) {
              // Next we find the first one that isn't the same which should be the
              // frame that called our sample function and the control.
              if (sampleLines[s] !== controlLines[c]) {
                // In V8, the first line is describing the message but other VMs don't.
                // If we're about to return the first line, and the control is also on the same
                // line, that's a pretty good indicator that our sample threw at same line as
                // the control. I.e. before we entered the sample frame. So we ignore this result.
                // This can happen if you passed a class to function component, or non-function.
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--; // We may still have similar intermediate frames from the construct call.
                    // The next one that isn't the same should be our match though.

                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                      var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                      {
                        if (typeof fn === 'function') {
                          componentFrameCache.set(fn, _frame);
                        }
                      } // Return the line we found.

                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }

                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.


        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        {
          if (typeof fn === 'function') {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }

      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }

      function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
      }

      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return '';
        }

        if (typeof type === 'function') {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }

        if (typeof type === 'string') {
          return describeBuiltInComponentFrame(type);
        }

        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame('Suspense');

          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame('SuspenseList');
        }

        if (typeof type === 'object') {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);

            case REACT_MEMO_TYPE:
              // Memo may contain any component type so we recursively resolve it.
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

            case REACT_BLOCK_TYPE:
              return describeFunctionComponentFrame(type._render);

            case REACT_LAZY_TYPE:
              {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;

                try {
                  // Lazy may contain any component type so we recursively resolve it.
                  return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
              }
          }
        }

        return '';
      }

      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }

      function checkPropTypes(typeSpecs, values, location, componentName, element) {
        {
          // $FlowFixMe This is okay but Flow doesn't know it.
          var has = Function.call.bind(Object.prototype.hasOwnProperty);

          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
              // fail the render phase where it didn't fail before. So we log it.
              // After these have been cleaned up, we'll let them throw.

              try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                  var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                  err.name = 'Invariant Violation';
                  throw err;
                }

                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
              } catch (ex) {
                error$1 = ex;
              }

              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }

              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }

      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      var didWarnAboutStringRefs;
      {
        didWarnAboutStringRefs = {};
      }

      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== undefined;
      }

      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== undefined;
      }

      function warnIfStringRefCannotBeAutoConverted(config, self) {
        {
          if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentName(ReactCurrentOwner.current.type);

            if (!didWarnAboutStringRefs[componentName]) {
              error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);
              didWarnAboutStringRefs[componentName] = true;
            }
          }
        }
      }

      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function () {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
            }
          };

          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }

      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function () {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
            }
          };

          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      /**
       * Factory method to create a new React element. This no longer adheres to
       * the class pattern, so do not use new to call it. Also, instanceof check
       * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
       * if something is a React Element.
       *
       * @param {*} type
       * @param {*} props
       * @param {*} key
       * @param {string|object} ref
       * @param {*} owner
       * @param {*} self A *temporary* helper to detect places where `this` is
       * different from the `owner` when React.createElement is called, so that we
       * can warn. We want to get rid of owner and replace string `ref`s with arrow
       * functions, and as long as `this` and owner are the same, there will be no
       * change in behavior.
       * @param {*} source An annotation object (added by a transpiler or otherwise)
       * indicating filename, line number, and/or other information.
       * @internal
       */


      var ReactElement = function (type, key, ref, self, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type: type,
          key: key,
          ref: ref,
          props: props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          // The validation flag is currently mutative. We put it on
          // an external backing store so that we can freeze the whole object.
          // This can be replaced with a WeakMap once they are implemented in
          // commonly used development environments.
          element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
          // the validation flag non-enumerable (where possible, which should
          // include every environment we run tests in), so the test framework
          // ignores it.

          Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          }); // self and source are DEV only properties.

          Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
          }); // Two elements created in two different places should be considered
          // equal for testing purposes and therefore we hide it from enumeration.

          Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });

          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      /**
       * https://github.com/reactjs/rfcs/pull/107
       * @param {*} type
       * @param {object} props
       * @param {string} key
       */


      function jsxDEV(type, config, maybeKey, source, self) {
        {
          var propName; // Reserved names are extracted

          var props = {};
          var key = null;
          var ref = null; // Currently, key can be spread in as a prop. This causes a potential
          // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
          // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
          // but as an intermediary step, we will use jsxDEV for everything except
          // <div {...props} key="Hi" />, because we aren't currently able to tell if
          // key is explicitly declared to be undefined or not.

          if (maybeKey !== undefined) {
            key = '' + maybeKey;
          }

          if (hasValidKey(config)) {
            key = '' + config.key;
          }

          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
          } // Remaining properties are added to a new props object


          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          } // Resolve default props


          if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;

            for (propName in defaultProps) {
              if (props[propName] === undefined) {
                props[propName] = defaultProps[propName];
              }
            }
          }

          if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }

            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }

          return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
        }
      }

      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }

      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      /**
       * Verifies the object is a ReactElement.
       * See https://reactjs.org/docs/react-api.html#isvalidelement
       * @param {?object} object
       * @return {boolean} True if `object` is a ReactElement.
       * @final
       */

      function isValidElement(object) {
        {
          return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }

      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentName(ReactCurrentOwner$1.current.type);

            if (name) {
              return '\n\nCheck the render method of `' + name + '`.';
            }
          }

          return '';
        }
      }

      function getSourceInfoErrorAddendum(source) {
        {
          if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, '');
            var lineNumber = source.lineNumber;
            return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
          }

          return '';
        }
      }
      /**
       * Warn if there's no key explicitly set on dynamic arrays of children or
       * object keys are not valid. This allows us to keep track of children between
       * updates.
       */


      var ownerHasKeyUseWarning = {};

      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();

          if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }

          return info;
        }
      }
      /**
       * Warn if the element doesn't have an explicit key assigned to it.
       * This element is in an array. The array could grow and shrink or be
       * reordered. All children that haven't already been validated are required to
       * have a "key" property assigned to it. Error statuses are cached so a warning
       * will only be shown once.
       *
       * @internal
       * @param {ReactElement} element Element that requires a key.
       * @param {*} parentType element's parent's type.
       */


      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }

          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }

          ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
          // property, it may be the creator of the child that's responsible for
          // assigning it a key.

          var childOwner = '';

          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            // Give the component that originally created this child.
            childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
          }

          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      /**
       * Ensure that every element either is passed in a static location, in an
       * array with an explicit keys property defined, or in an object literal
       * with valid key property.
       *
       * @internal
       * @param {ReactNode} node Statically passed child of any type.
       * @param {*} parentType node's parent's type.
       */


      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== 'object') {
            return;
          }

          if (Array.isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];

              if (isValidElement(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement(node)) {
            // This element was passed in a valid location.
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);

            if (typeof iteratorFn === 'function') {
              // Entry iterators used to provide implicit keys,
              // but now we print a separate warning for them later.
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;

                while (!(step = iterator.next()).done) {
                  if (isValidElement(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      /**
       * Given an element, validate that its props follow the propTypes definition,
       * provided by the type.
       *
       * @param {ReactElement} element
       */


      function validatePropTypes(element) {
        {
          var type = element.type;

          if (type === null || type === undefined || typeof type === 'string') {
            return;
          }

          var propTypes;

          if (typeof type === 'function') {
            propTypes = type.propTypes;
          } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }

          if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentName(type);
            checkPropTypes(propTypes, element.props, 'prop', name, element);
          } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

            var _name = getComponentName(type);

            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
          }

          if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
            error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
          }
        }
      }
      /**
       * Given a fragment, validate that it can only be provided with fragment props
       * @param {ReactElement} fragment
       */


      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);

          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];

            if (key !== 'children' && key !== 'key') {
              setCurrentlyValidatingElement$1(fragment);
              error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }

          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
            setCurrentlyValidatingElement$1(null);
          }
        }
      }

      function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        {
          var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
          // succeed and there will likely be errors in render.

          if (!validType) {
            var info = '';

            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
              info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
            }

            var sourceInfo = getSourceInfoErrorAddendum(source);

            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }

            var typeString;

            if (type === null) {
              typeString = 'null';
            } else if (Array.isArray(type)) {
              typeString = 'array';
            } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
              info = ' Did you accidentally export a JSX literal instead of a component?';
            } else {
              typeString = typeof type;
            }

            error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
          }

          var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
          // TODO: Drop this when these are no longer allowed as the type argument.

          if (element == null) {
            return element;
          } // Skip key warning if the type isn't valid since our key validation logic
          // doesn't expect a non-string/function type and can throw confusing errors.
          // We don't want exception behavior to differ between dev and prod.
          // (Rendering will throw with a helpful message and as soon as the type is
          // fixed, the key warnings will appear.)


          if (validType) {
            var children = props.children;

            if (children !== undefined) {
              if (isStaticChildren) {
                if (Array.isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }

                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }

          if (type === exports.Fragment) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }

          return element;
        }
      } // These two functions exist to still get child warnings in dev
      // even with the prod transform. This means that jsxDEV is purely
      // opt-in behavior for better messages but that we won't stop
      // giving you warnings if you use production apis.


      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }

      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }

      var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
      // for now we can ship identical prod functions

      var jsxs = jsxWithValidationStatic;
      exports.jsx = jsx;
      exports.jsxs = jsxs;
    })();
  }
});

var jsxRuntime = createCommonjsModule(function (module) {

  if (process.env.NODE_ENV === 'production') {
    module.exports = reactJsxRuntime_production_min;
  } else {
    module.exports = reactJsxRuntime_development;
  }
});

var ThemeContext = /*#__PURE__*/createContext();

var ThemeStore = function ThemeStore(_ref) {
  var children = _ref.children;

  var _useState = useState("dark"),
      _useState2 = _slicedToArray(_useState, 2),
      theme = _useState2[0],
      setTheme = _useState2[1];

  var switchTheme = function switchTheme(theme) {
    return setTheme(theme);
  };

  return /*#__PURE__*/jsxRuntime.jsx(ThemeContext.Provider, {
    value: {
      switchTheme: switchTheme,
      theme: theme
    },
    children: children
  });
};

var _templateObject$G;
var NormalizeStyle = createGlobalStyle(_templateObject$G || (_templateObject$G = _taggedTemplateLiteral(["\n    /*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\n\n    /* Document\n       ========================================================================== */\n\n    /**\n     * 1. Correct the line height in all browsers.\n     * 2. Prevent adjustments of font size after orientation changes in iOS.\n     */\n\n    html {\n        line-height: 1.15; /* 1 */\n        -webkit-text-size-adjust: 100%; /* 2 */\n    }\n\n    /* Sections\n       ========================================================================== */\n\n    /**\n     * Remove the margin in all browsers.\n     */\n\n    body {\n        margin: 0;\n    }\n\n    /**\n     * Render the `main` element consistently in IE.\n     */\n\n    main {\n        display: block;\n    }\n\n    /**\n     * Correct the font size and margin on `h1` elements within `section` and\n     * `article` contexts in Chrome, Firefox, and Safari.\n     */\n\n    h1 {\n        font-size: 2em;\n        margin: 0.67em 0;\n    }\n\n    /* Grouping content\n       ========================================================================== */\n\n    /**\n     * 1. Add the correct box sizing in Firefox.\n     * 2. Show the overflow in Edge and IE.\n     */\n\n    hr {\n        box-sizing: content-box; /* 1 */\n        height: 0; /* 1 */\n        overflow: visible; /* 2 */\n    }\n\n    /**\n     * 1. Correct the inheritance and scaling of font size in all browsers.\n     * 2. Correct the odd `em` font sizing in all browsers.\n     */\n\n    pre {\n        font-family: monospace, monospace; /* 1 */\n        font-size: 1em; /* 2 */\n    }\n\n    /* Text-level semantics\n       ========================================================================== */\n\n    /**\n     * Remove the gray background on active links in IE 10.\n     */\n\n    a {\n        background-color: transparent;\n    }\n\n    /**\n     * 1. Remove the bottom border in Chrome 57-\n     * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n     */\n\n    abbr[title] {\n        border-bottom: none; /* 1 */\n        text-decoration: underline; /* 2 */\n        text-decoration: underline dotted; /* 2 */\n    }\n\n    /**\n     * Add the correct font weight in Chrome, Edge, and Safari.\n     */\n\n    b,\n    strong {\n        font-weight: bolder;\n    }\n\n    /**\n     * 1. Correct the inheritance and scaling of font size in all browsers.\n     * 2. Correct the odd `em` font sizing in all browsers.\n     */\n\n    code,\n    kbd,\n    samp {\n        font-family: monospace, monospace; /* 1 */\n        font-size: 1em; /* 2 */\n    }\n\n    /**\n     * Add the correct font size in all browsers.\n     */\n\n    small {\n        font-size: 80%;\n    }\n\n    /**\n     * Prevent `sub` and `sup` elements from affecting the line height in\n     * all browsers.\n     */\n\n    sub,\n    sup {\n        font-size: 75%;\n        line-height: 0;\n        position: relative;\n        vertical-align: baseline;\n    }\n\n    sub {\n        bottom: -0.25em;\n    }\n\n    sup {\n        top: -0.5em;\n    }\n\n    /* Embedded content\n       ========================================================================== */\n\n    /**\n     * Remove the border on images inside links in IE 10.\n     */\n\n    img {\n        border-style: none;\n    }\n\n    /* Forms\n       ========================================================================== */\n\n    /**\n     * 1. Change the font styles in all browsers.\n     * 2. Remove the margin in Firefox and Safari.\n     */\n\n    button,\n    input,\n    optgroup,\n    select,\n    textarea {\n        font-family: inherit; /* 1 */\n        font-size: 100%; /* 1 */\n        line-height: 1.15; /* 1 */\n        margin: 0; /* 2 */\n    }\n\n    /**\n     * Show the overflow in IE.\n     * 1. Show the overflow in Edge.\n     */\n\n    button,\n    input { /* 1 */\n        overflow: visible;\n    }\n\n    /**\n     * Remove the inheritance of text transform in Edge, Firefox, and IE.\n     * 1. Remove the inheritance of text transform in Firefox.\n     */\n\n    button,\n    select { /* 1 */\n        text-transform: none;\n    }\n\n    /**\n     * Correct the inability to style clickable types in iOS and Safari.\n     */\n\n    button,\n    [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"] {\n        -webkit-appearance: button;\n    }\n\n    /**\n     * Remove the inner border and padding in Firefox.\n     */\n\n    button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner {\n        border-style: none;\n        padding: 0;\n    }\n\n    /**\n     * Restore the focus styles unset by the previous rule.\n     */\n\n    button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring {\n        outline: 1px dotted ButtonText;\n    }\n\n    /**\n     * Correct the padding in Firefox.\n     */\n\n    fieldset {\n        padding: 0.35em 0.75em 0.625em;\n    }\n\n    /**\n     * 1. Correct the text wrapping in Edge and IE.\n     * 2. Correct the color inheritance from `fieldset` elements in IE.\n     * 3. Remove the padding so developers are not caught out when they zero out\n     *    `fieldset` elements in all browsers.\n     */\n\n    legend {\n        box-sizing: border-box; /* 1 */\n        color: inherit; /* 2 */\n        display: table; /* 1 */\n        max-width: 100%; /* 1 */\n        padding: 0; /* 3 */\n        white-space: normal; /* 1 */\n    }\n\n    /**\n     * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n     */\n\n    progress {\n        vertical-align: baseline;\n    }\n\n    /**\n     * Remove the default vertical scrollbar in IE 10+.\n     */\n\n    textarea {\n        overflow: auto;\n    }\n\n    /**\n     * 1. Add the correct box sizing in IE 10.\n     * 2. Remove the padding in IE 10.\n     */\n\n    [type=\"checkbox\"],\n    [type=\"radio\"] {\n        box-sizing: border-box; /* 1 */\n        padding: 0; /* 2 */\n    }\n\n    /**\n     * Correct the cursor style of increment and decrement buttons in Chrome.\n     */\n\n    [type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button {\n        height: auto;\n    }\n\n    /**\n     * 1. Correct the odd appearance in Chrome and Safari.\n     * 2. Correct the outline style in Safari.\n     */\n\n    [type=\"search\"] {\n        -webkit-appearance: textfield; /* 1 */\n        outline-offset: -2px; /* 2 */\n    }\n\n    /**\n     * Remove the inner padding in Chrome and Safari on macOS.\n     */\n\n    [type=\"search\"]::-webkit-search-decoration {\n        -webkit-appearance: none;\n    }\n\n    /**\n     * 1. Correct the inability to style clickable types in iOS and Safari.\n     * 2. Change font properties to `inherit` in Safari.\n     */\n\n    ::-webkit-file-upload-button {\n        -webkit-appearance: button; /* 1 */\n        font: inherit; /* 2 */\n    }\n\n    /* Interactive\n       ========================================================================== */\n\n    /*\n     * Add the correct display in Edge, IE 10+, and Firefox.\n     */\n\n    details {\n        display: block;\n    }\n\n    /*\n     * Add the correct display in all browsers.\n     */\n\n    summary {\n        display: list-item;\n    }\n\n    /* Misc\n       ========================================================================== */\n\n    /**\n     * Add the correct display in IE 10+.\n     */\n\n    template {\n        display: none;\n    }\n\n    /**\n     * Add the correct display in IE 10.\n     */\n\n    [hidden] {\n        display: none;\n    }\n"], ["\n    /*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\n\n    /* Document\n       ========================================================================== */\n\n    /**\n     * 1. Correct the line height in all browsers.\n     * 2. Prevent adjustments of font size after orientation changes in iOS.\n     */\n\n    html {\n        line-height: 1.15; /* 1 */\n        -webkit-text-size-adjust: 100%; /* 2 */\n    }\n\n    /* Sections\n       ========================================================================== */\n\n    /**\n     * Remove the margin in all browsers.\n     */\n\n    body {\n        margin: 0;\n    }\n\n    /**\n     * Render the \\`main\\` element consistently in IE.\n     */\n\n    main {\n        display: block;\n    }\n\n    /**\n     * Correct the font size and margin on \\`h1\\` elements within \\`section\\` and\n     * \\`article\\` contexts in Chrome, Firefox, and Safari.\n     */\n\n    h1 {\n        font-size: 2em;\n        margin: 0.67em 0;\n    }\n\n    /* Grouping content\n       ========================================================================== */\n\n    /**\n     * 1. Add the correct box sizing in Firefox.\n     * 2. Show the overflow in Edge and IE.\n     */\n\n    hr {\n        box-sizing: content-box; /* 1 */\n        height: 0; /* 1 */\n        overflow: visible; /* 2 */\n    }\n\n    /**\n     * 1. Correct the inheritance and scaling of font size in all browsers.\n     * 2. Correct the odd \\`em\\` font sizing in all browsers.\n     */\n\n    pre {\n        font-family: monospace, monospace; /* 1 */\n        font-size: 1em; /* 2 */\n    }\n\n    /* Text-level semantics\n       ========================================================================== */\n\n    /**\n     * Remove the gray background on active links in IE 10.\n     */\n\n    a {\n        background-color: transparent;\n    }\n\n    /**\n     * 1. Remove the bottom border in Chrome 57-\n     * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n     */\n\n    abbr[title] {\n        border-bottom: none; /* 1 */\n        text-decoration: underline; /* 2 */\n        text-decoration: underline dotted; /* 2 */\n    }\n\n    /**\n     * Add the correct font weight in Chrome, Edge, and Safari.\n     */\n\n    b,\n    strong {\n        font-weight: bolder;\n    }\n\n    /**\n     * 1. Correct the inheritance and scaling of font size in all browsers.\n     * 2. Correct the odd \\`em\\` font sizing in all browsers.\n     */\n\n    code,\n    kbd,\n    samp {\n        font-family: monospace, monospace; /* 1 */\n        font-size: 1em; /* 2 */\n    }\n\n    /**\n     * Add the correct font size in all browsers.\n     */\n\n    small {\n        font-size: 80%;\n    }\n\n    /**\n     * Prevent \\`sub\\` and \\`sup\\` elements from affecting the line height in\n     * all browsers.\n     */\n\n    sub,\n    sup {\n        font-size: 75%;\n        line-height: 0;\n        position: relative;\n        vertical-align: baseline;\n    }\n\n    sub {\n        bottom: -0.25em;\n    }\n\n    sup {\n        top: -0.5em;\n    }\n\n    /* Embedded content\n       ========================================================================== */\n\n    /**\n     * Remove the border on images inside links in IE 10.\n     */\n\n    img {\n        border-style: none;\n    }\n\n    /* Forms\n       ========================================================================== */\n\n    /**\n     * 1. Change the font styles in all browsers.\n     * 2. Remove the margin in Firefox and Safari.\n     */\n\n    button,\n    input,\n    optgroup,\n    select,\n    textarea {\n        font-family: inherit; /* 1 */\n        font-size: 100%; /* 1 */\n        line-height: 1.15; /* 1 */\n        margin: 0; /* 2 */\n    }\n\n    /**\n     * Show the overflow in IE.\n     * 1. Show the overflow in Edge.\n     */\n\n    button,\n    input { /* 1 */\n        overflow: visible;\n    }\n\n    /**\n     * Remove the inheritance of text transform in Edge, Firefox, and IE.\n     * 1. Remove the inheritance of text transform in Firefox.\n     */\n\n    button,\n    select { /* 1 */\n        text-transform: none;\n    }\n\n    /**\n     * Correct the inability to style clickable types in iOS and Safari.\n     */\n\n    button,\n    [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"] {\n        -webkit-appearance: button;\n    }\n\n    /**\n     * Remove the inner border and padding in Firefox.\n     */\n\n    button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner {\n        border-style: none;\n        padding: 0;\n    }\n\n    /**\n     * Restore the focus styles unset by the previous rule.\n     */\n\n    button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring {\n        outline: 1px dotted ButtonText;\n    }\n\n    /**\n     * Correct the padding in Firefox.\n     */\n\n    fieldset {\n        padding: 0.35em 0.75em 0.625em;\n    }\n\n    /**\n     * 1. Correct the text wrapping in Edge and IE.\n     * 2. Correct the color inheritance from \\`fieldset\\` elements in IE.\n     * 3. Remove the padding so developers are not caught out when they zero out\n     *    \\`fieldset\\` elements in all browsers.\n     */\n\n    legend {\n        box-sizing: border-box; /* 1 */\n        color: inherit; /* 2 */\n        display: table; /* 1 */\n        max-width: 100%; /* 1 */\n        padding: 0; /* 3 */\n        white-space: normal; /* 1 */\n    }\n\n    /**\n     * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n     */\n\n    progress {\n        vertical-align: baseline;\n    }\n\n    /**\n     * Remove the default vertical scrollbar in IE 10+.\n     */\n\n    textarea {\n        overflow: auto;\n    }\n\n    /**\n     * 1. Add the correct box sizing in IE 10.\n     * 2. Remove the padding in IE 10.\n     */\n\n    [type=\"checkbox\"],\n    [type=\"radio\"] {\n        box-sizing: border-box; /* 1 */\n        padding: 0; /* 2 */\n    }\n\n    /**\n     * Correct the cursor style of increment and decrement buttons in Chrome.\n     */\n\n    [type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button {\n        height: auto;\n    }\n\n    /**\n     * 1. Correct the odd appearance in Chrome and Safari.\n     * 2. Correct the outline style in Safari.\n     */\n\n    [type=\"search\"] {\n        -webkit-appearance: textfield; /* 1 */\n        outline-offset: -2px; /* 2 */\n    }\n\n    /**\n     * Remove the inner padding in Chrome and Safari on macOS.\n     */\n\n    [type=\"search\"]::-webkit-search-decoration {\n        -webkit-appearance: none;\n    }\n\n    /**\n     * 1. Correct the inability to style clickable types in iOS and Safari.\n     * 2. Change font properties to \\`inherit\\` in Safari.\n     */\n\n    ::-webkit-file-upload-button {\n        -webkit-appearance: button; /* 1 */\n        font: inherit; /* 2 */\n    }\n\n    /* Interactive\n       ========================================================================== */\n\n    /*\n     * Add the correct display in Edge, IE 10+, and Firefox.\n     */\n\n    details {\n        display: block;\n    }\n\n    /*\n     * Add the correct display in all browsers.\n     */\n\n    summary {\n        display: list-item;\n    }\n\n    /* Misc\n       ========================================================================== */\n\n    /**\n     * Add the correct display in IE 10+.\n     */\n\n    template {\n        display: none;\n    }\n\n    /**\n     * Add the correct display in IE 10.\n     */\n\n    [hidden] {\n        display: none;\n    }\n"])));

var ColorSchemeContext = /*#__PURE__*/createContext(defaultColorScheme);

var ColorSchemeStore = function ColorSchemeStore(_ref) {
  var children = _ref.children;

  var _useState = useState(defaultColorScheme),
      _useState2 = _slicedToArray(_useState, 2),
      colorScheme = _useState2[0],
      setColorScheme = _useState2[1];

  var switchColorScheme = function switchColorScheme(colorScheme) {
    return setColorScheme(colorScheme);
  };

  return /*#__PURE__*/jsxRuntime.jsx(ColorSchemeContext.Provider, {
    value: {
      switchColorScheme: switchColorScheme,
      colorScheme: colorScheme
    },
    children: children
  });
};

var _templateObject$F;
var GlobalStyle = createGlobalStyle(_templateObject$F || (_templateObject$F = _taggedTemplateLiteral(["\n    * {\n        margin: 0;\n        padding: 0;\n    }\n\n    body {\n        background-color: ", ";\n        overflow: auto;\n    }\n\n    p {\n        margin: ", " 0;\n        line-height: 1.4rem;\n    }\n"])), function (props) {
  return props.theme.color.light;
}, space(3));

var variables = {
  shadow: {
    normal: "0 4px 8px 0 rgba(0,0,0,0.2)",
    hover: "0 8px 16px 0 rgba(0,0,0,0.2)"
  },
  borderRadius: space(1)
};
var components = {
  topBar: {
    height: "56px",
    logo: {
      height: "40px"
    }
  },
  input: {
    height: "24px",
    lineHeight: "1.8rem"
  },
  select: {
    height: "44px",
    lineHeight: "1.8rem"
  }
};

var themes = function themes(colorScheme) {
  return {
    dark: {
      scheme: colorScheme,
      components: _objectSpread2(_objectSpread2({}, components), {}, {
        card: {
          backgroundColor: colorScheme.dark.normal
        },
        input: _objectSpread2(_objectSpread2({}, components.input), {}, {
          borderColor: colorScheme.light.normal,
          backgroundColor: colorScheme.light.normal
        })
      }),
      variables: variables,
      color: colorScheme.dark,
      invertColor: colorScheme.light
    },
    light: {
      scheme: colorScheme,
      components: _objectSpread2(_objectSpread2({}, components), {}, {
        card: {
          backgroundColor: colorScheme.light.light
        },
        input: _objectSpread2(_objectSpread2({}, components.input), {}, {
          borderColor: colorScheme.light.dark,
          backgroundColor: "transparent"
        })
      }),
      variables: variables,
      color: colorScheme.light,
      invertColor: colorScheme.dark
    }
  };
};

var ThemeContainer = function ThemeContainer(_ref) {
  var children = _ref.children;

  var _useContext = useContext(ThemeContext),
      theme = _useContext.theme; // get the current theme ('light' or 'dark')


  var colorScheme = useContext(ColorSchemeContext);
  return /*#__PURE__*/jsxRuntime.jsxs(ThemeProvider, {
    theme: themes(colorScheme)[theme],
    children: [/*#__PURE__*/jsxRuntime.jsx(NormalizeStyle, {}), /*#__PURE__*/jsxRuntime.jsx(GlobalStyle, {
      theme: themes[theme]
    }), children]
  });
};

var _templateObject$E;
var Container$a = styled.div(_templateObject$E || (_templateObject$E = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n    padding: ", ";\n    border-radius: ", ";\n    transition: background-color 0.2s linear;\n    cursor: pointer;\n    display: inline-block;\n\n    &:hover {\n        background-color: ", ";\n        transition: background-color 0.2s linear;\n    }\n"])), function (props) {
  return props.theme.invertColor;
}, function (props) {
  return props.theme.color;
}, space(2), space(1), function (props) {
  return props.theme.scheme.primary.normal;
});
var ThemeSwitcher = function ThemeSwitcher(_ref) {
  var lightIcon = _ref.lightIcon,
      darkIcon = _ref.darkIcon;

  var _useContext = useContext(ThemeContext),
      theme = _useContext.theme,
      switchTheme = _useContext.switchTheme;

  var handleOnClick = function handleOnClick(theme) {
    return switchTheme(theme);
  };

  return /*#__PURE__*/jsxRuntime.jsx(Container$a, {
    themeSelected: theme,
    onClick: function onClick() {
      return handleOnClick(theme === "light" ? "dark" : "light");
    },
    children: theme === "light" ? lightIcon : darkIcon
  });
};
ThemeSwitcher.propTypes = {
  lightIcon: propTypes.element.isRequired,
  darkIcon: propTypes.element.isRequired
};

var IconContext = /*#__PURE__*/createContext({});

var _templateObject$D;
var Button = styled.button(_templateObject$D || (_templateObject$D = _taggedTemplateLiteral(["\n    padding: ", " ", ";\n    width: ", ";\n    transition: all 0.2s linear;\n    display: block;\n    margin-bottom: 0;\n    font-weight: 400;\n    text-align: center;\n    vertical-align: middle;\n    touch-action: manipulation;\n    cursor: pointer;\n    background-image: none;\n    border: 1px solid transparent;\n    font-size: 0.875rem;\n    line-height: 1.75;\n    border-radius: ", ";\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2);\n    background-color: ", ";\n    color: ", ";\n    outline: none;\n\n\n    :hover, :active, :focus {\n        background-color: ", ";\n        transition: background-color 0.2s linear;\n    }\n\n    :disabled {\n        background-color: ", ";\n        box-shadow: none;\n        color: ", ";\n    }\n"])), space(1), space(3), function (props) {
  return props.block && "100%";
}, space(1), function (props) {
  return props.theme.scheme[props.variant].normal;
}, function (props) {
  return props.theme.scheme[props.variant].color;
}, function (props) {
  return props.theme.scheme[props.variant].dark;
}, function (props) {
  return props.theme.scheme[Variant.LIGHT].normal;
}, function (props) {
  return props.theme.scheme[Variant.LIGHT].dark;
});
Button.propTypes = {
  variant: propTypes.string,
  type: propTypes.oneOf(["button", "submit", "reset"]),
  block: propTypes.bool,
  loading: propTypes.bool
};
Button.defaultProps = {
  variant: Variant.PRIMARY,
  type: "button",
  block: false,
  loading: false
};

var _templateObject$C;
var CircleButton = styled(Button)(_templateObject$C || (_templateObject$C = _taggedTemplateLiteral(["\n    padding: ", ";\n    height: 48px;\n    width: 48px;\n    border: transparent;\n    border-radius: 100%;\n    user-select: none;\n    line-height: 1;\n"])), space(2));
CircleButton.propTypes = {
  variant: propTypes.string
};
CircleButton.defaultProps = {
  variant: Variant.PRIMARY
};

var _templateObject$B;
var IconButton = styled(Button)(_templateObject$B || (_templateObject$B = _taggedTemplateLiteral(["\n    padding: 0;\n    height: 36px;\n    width: 36px;\n    color: ", ";\n    border: transparent;\n    user-select: none;\n    box-shadow: none;\n    background-color: transparent;\n    line-height: 1;\n    border-radius: 50%;\n    transition: all 0.2s linear;\n\n    &:hover {\n        background-color: ", ";\n        color: ", ";\n        transition: all 0.2s linear;\n    }\n\n    > svg {\n        height: 24px;\n        width: 24px;\n    }\n"])), function (props) {
  return props.theme.scheme[props.variant].normal;
}, function (props) {
  return props.theme.scheme[props.variant].normal;
}, function (props) {
  return props.theme.scheme[Variant.LIGHT].light;
});
Button.propTypes = {
  variant: propTypes.oneOfType([propTypes.oneOf([Variant]), propTypes.string])
};
Button.defaultProps = {
  variant: Variant.PRIMARY
};

var _templateObject$A;
var MinimalButton = styled(CircleButton)(_templateObject$A || (_templateObject$A = _taggedTemplateLiteral(["\n    padding: ", ";\n    background-color: transparent;\n    box-shadow: none;\n    border-radius: 50%;\n    height: 32px;\n    width: 32px;\n    transition: color 0.2s linear;\n\n    > * {\n        color: ", ";\n        height: 70%;\n        width: 70%;\n        transition: color 0.2s linear;\n    }\n\n    :hover {\n        > * {\n            color: ", ";\n            height: 70%;\n            width: 70%;\n            transition: color 0.2s linear;\n        }\n    }\n"])), space(1), function (props) {
  return props.theme.scheme[props.variant].normal;
}, function (props) {
  return props.theme.color;
});
MinimalButton.propTypes = {
  variant: propTypes.string,
  type: propTypes.oneOf(["button", "submit", "reset"])
};
MinimalButton.defaultProps = {
  variant: Variant.LIGHT,
  type: "button"
};

var _templateObject$z;
var RoundedButton = styled(Button)(_templateObject$z || (_templateObject$z = _taggedTemplateLiteral(["\n    border-radius: ", ";\n    background-color: ", ";\n    color: ", ";\n\n    :hover {\n        background-color: ", ";\n    }\n"])), space(3), function (props) {
  return props.theme.scheme[props.variant].normal;
}, function (props) {
  return props.theme.scheme[props.variant].color;
}, function (props) {
  return props.theme.scheme[props.variant].dark;
});
RoundedButton.propTypes = {
  variant: propTypes.string
};
RoundedButton.defaultProps = {
  variant: Variant.PRIMARY
};

var _templateObject$y;
var CloseButton$1 = styled.span(_templateObject$y || (_templateObject$y = _taggedTemplateLiteral(["\n    position: absolute;\n    right: ", ";\n    top: ", ";\n    color: ", ";\n    transition: color 0.2s linear;\n    height: 22px;\n    width: 22px;\n\n    :hover {\n        color: ", ";\n        transition: color 0.2s linear;\n        cursor: pointer;\n    }\n"])), space(1), space(1), function (props) {
  return props.theme.scheme[props.variant].light;
}, function (props) {
  return props.theme.scheme[props.variant].dark;
});
CloseButton$1.propTypes = {
  variant: propTypes.oneOfType([propTypes.oneOf([Variant]), propTypes.string])
};
CloseButton$1.defaultProps = {
  variant: Variant.PRIMARY
};

var _templateObject$x;
var TextButton = styled(Button)(_templateObject$x || (_templateObject$x = _taggedTemplateLiteral(["\n    background-color: transparent;\n    color: ", ";\n    font-weight: 600;\n    box-shadow: none;\n\n    :hover, :active, :focus {\n        background-color: ", ";\n        transition: background-color 0.2s linear;\n    }\n\n    :disabled {\n        background-color: ", ";\n        box-shadow: none;\n        color: ", ";\n    }\n"])), function (props) {
  return props.theme.scheme[props.variant].normal;
}, function (props) {
  return props.theme.scheme[props.variant].light;
}, function (props) {
  return props.theme.scheme[Variant.LIGHT].normal;
}, function (props) {
  return props.theme.scheme[Variant.LIGHT].dark;
});
TextButton.propTypes = {
  variant: propTypes.string,
  type: propTypes.oneOf(["button", "submit", "reset"]),
  block: propTypes.bool,
  loading: propTypes.bool
};
TextButton.defaultProps = {
  variant: Variant.PRIMARY,
  type: "button",
  block: false,
  loading: false
};

var _templateObject$w, _templateObject2$k, _templateObject3$e, _templateObject4$a, _templateObject5$8;
var AlertStylised = styled.div(_templateObject$w || (_templateObject$w = _taggedTemplateLiteral(["\n    position: relative;\n    border-radius: ", ";\n    padding: ", ";\n    box-sizing: border-box;\n    background: ", ";\n    border: 2px solid ", ";\n    color: ", ";\n    display: flex;\n    flex-direction: row-reverse;\n    align-items: flex-start;\n"])), space(1), space(2), function (props) {
  return props.theme.scheme[props.variant].light;
}, function (props) {
  return props.theme.color === props.theme.scheme[props.variant] ? props.theme.invertColor.normal : props.theme.scheme[props.variant].normal;
}, function (props) {
  return props.theme.color.normal;
});
var GrowElem = styled.div(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteral(["\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    align-self: center;\n"])));
var Title$5 = styled.span(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteral(["\n    font-weight: 600;\n    color: ", ";\n"])), function (props) {
  return props.theme.scheme[props.variant].dark;
});
var TitleContainer = styled.div(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteral(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n    display: flex;\n    align-items: flex-end;\n"])), space(1), space(2));
var Icon$2 = styled.i(_templateObject5$8 || (_templateObject5$8 = _taggedTemplateLiteral(["\n    color: ", ";\n    margin-right: ", ";\n    margin-bottom: 2px;\n\n    > svg {\n        height: 20px;\n        width: 20px;\n    }\n"])), function (props) {
  return props.theme.scheme[props.variant].dark;
}, space(2));
var Alert = function Alert(_ref) {
  var children = _ref.children,
      variant = _ref.variant,
      title = _ref.title;
  var icons = useContext(IconContext);

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  return visible && /*#__PURE__*/jsxRuntime.jsxs(AlertStylised, {
    variant: variant,
    children: [/*#__PURE__*/jsxRuntime.jsx(CloseButton$1, {
      variant: variant,
      onClick: function onClick() {
        return setVisible(false);
      },
      children: icons.close
    }), /*#__PURE__*/jsxRuntime.jsxs(GrowElem, {
      children: [title && /*#__PURE__*/jsxRuntime.jsxs(TitleContainer, {
        children: [/*#__PURE__*/jsxRuntime.jsx(Icon$2, {
          variant: variant,
          children: icons[variant]
        }), /*#__PURE__*/jsxRuntime.jsx(Title$5, {
          variant: variant,
          children: title
        })]
      }), /*#__PURE__*/jsxRuntime.jsx(jsxRuntime.Fragment, {
        children: children
      })]
    })]
  });
};
Alert.propTypes = {
  variant: propTypes.oneOfType([propTypes.oneOf([Variant]), propTypes.string]),
  title: propTypes.string
};
Alert.defaultProps = {
  variant: Variant.PRIMARY
};

var _templateObject$v, _templateObject2$j;
var Wrapper$2 = styled.div(_templateObject$v || (_templateObject$v = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: auto;\n\n    pre {\n        text-align: center;\n        font-size: 0.8em;\n        color: ", ";\n    }\n"])), function (props) {
  return props.theme.color;
});
var Ellipsis = styled.div(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteral(["\n    display: inline-block;\n    position: relative;\n    width: 80px;\n    height: 80px;\n\n    @keyframes lds-ellipsis1 {\n        0% {\n            transform: scale(0);\n        }\n        100% {\n            transform: scale(1);\n        }\n    }\n    @keyframes lds-ellipsis3 {\n        0% {\n            transform: scale(1);\n        }\n        100% {\n            transform: scale(0);\n        }\n    }\n    @keyframes lds-ellipsis2 {\n        0% {\n            transform: translate(0, 0);\n        }\n        100% {\n            transform: translate(24px, 0);\n        }\n    }\n\n    div {\n        position: absolute;\n        top: 33px;\n        width: 13px;\n        height: 13px;\n        border-radius: 50%;\n        background: ", ";\n        animation-timing-function: cubic-bezier(0, 1, 1, 0);\n\n        &:nth-child(1) {\n            left: 8px;\n            animation: lds-ellipsis1 0.6s infinite;\n        }\n\n        &:nth-child(2) {\n            left: 8px;\n            animation: lds-ellipsis2 0.6s infinite;\n        }\n\n        &:nth-child(3) {\n            left: 32px;\n            animation: lds-ellipsis2 0.6s infinite;\n        }\n\n        &:nth-child(4) {\n            left: 56px;\n            animation: lds-ellipsis3 0.6s infinite;\n        }\n    }\n"])), function (props) {
  return props.theme.scheme[props.variant].normal;
});
function Loader(_ref) {
  var text = _ref.text,
      variant = _ref.variant;
  return /*#__PURE__*/jsxRuntime.jsxs(Wrapper$2, {
    children: [/*#__PURE__*/jsxRuntime.jsxs(Ellipsis, {
      variant: variant,
      children: [/*#__PURE__*/jsxRuntime.jsx("div", {}), /*#__PURE__*/jsxRuntime.jsx("div", {}), /*#__PURE__*/jsxRuntime.jsx("div", {}), /*#__PURE__*/jsxRuntime.jsx("div", {})]
    }), /*#__PURE__*/jsxRuntime.jsx("pre", {
      children: text
    })]
  });
}
Loader.propTypes = {
  text: propTypes.string,
  variant: propTypes.oneOfType([propTypes.oneOf([Variant]), propTypes.string])
};
Loader.defaultProps = {
  text: "Loading ...",
  variant: Variant.PRIMARY
};

var _templateObject$u;
var Logo = styled.img(_templateObject$u || (_templateObject$u = _taggedTemplateLiteral(["\n    width: 100%;\n    height: auto;\n"])));
Logo.propTypes = {
  src: propTypes.string.isRequired
};

/**
 * @param url
 * @param options
 * @returns {{data: unknown, error: unknown, loading: boolean}}
 */

function useFetch(url, options) {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      loading = _useState6[0],
      setLoading = _useState6[1];

  useEffect(function () {
    var abortController = new AbortController();
    var signal = abortController.signal;

    var doFetch = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, json;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setLoading(true);
                _context.prev = 1;
                _context.next = 4;
                return fetch(url, options ? options : {
                  headers: {
                    'Content-Type': 'application/json'
                  }
                });

              case 4:
                res = _context.sent;

                if (signal.aborted) {
                  _context.next = 12;
                  break;
                }

                _context.next = 8;
                return res.json();

              case 8:
                json = _context.sent;

                if (res.ok) {
                  _context.next = 11;
                  break;
                }

                throw json;

              case 11:
                setData(json);

              case 12:
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](1);
                if (!signal.aborted) setError(_context.t0);

              case 17:
                _context.prev = 17;
                if (!signal.aborted) setLoading(false);
                return _context.finish(17);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 14, 17, 20]]);
      }));

      return function doFetch() {
        return _ref.apply(this, arguments);
      };
    }();

    doFetch();
    return function () {
      abortController.abort();
    };
  }, [url]);
  return {
    data: data,
    error: error,
    loading: loading
  };
}

/**
 * Récupère la valeur dans le local storage à la clé spécifiée
 * @param key
 * @param initialValue
 */

function useLocalStorage(key, initialValue) {
  var _useState = useState(function () {
    try {
      var item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (e) {
      console.log(e); // if error return initialValue

      // if error return initialValue
      return initialValue;
    }
  }),
      _useState2 = _slicedToArray(_useState, 2),
      storedValue = _useState2[0],
      setStoredValue = _useState2[1];

  var setValue = function setValue(value) {
    try {
      var valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (e) {
      console.log(e);
    }
  };

  return [storedValue, setValue];
}

function reducer$1(state, action) {
  switch (action.type) {
    case 'LOADING':
      return _objectSpread2(_objectSpread2({}, state), {}, {
        loading: true
      });

    case 'ERROR':
      return _objectSpread2(_objectSpread2({}, state), {}, {
        loading: false,
        error: action.error
      });

    case 'DATA':
      return _objectSpread2(_objectSpread2({}, state), {}, {
        loading: false,
        data: action.data
      });
  }
}

function status(response) {
  if (!response.ok) return Promise.reject(response.text());
  return Promise.resolve(response);
}

function data(response) {
  var contentType = response.headers.get("content-type");
  console.log(contentType);
  return contentType && contentType === "application/json" ? response.json() : response.text();
}

var postFetch = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(endpoint, data, token) {
    var headers;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            headers = token ? new Headers({
              'content-type': 'application/json',
              'Authorization': 'Bearer ' + token
            }) : new Headers({
              'content-type': 'application/json'
            });
            return _context.abrupt("return", apiFetch(endpoint, {
              method: 'POST',
              headers: headers,
              body: JSON.stringify(data)
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function postFetch(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var uploadFetch = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(endpoint, data, token) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(endpoint, {
              method: 'POST',
              headers: new Headers({
                'Authorization': 'Bearer ' + token
              }),
              body: data
            });

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function uploadFetch(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

var deleteFetch = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(endpoint, token) {
    var headers;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            headers = token ? new Headers({
              'content-type': 'application/json',
              'Authorization': 'Bearer ' + token
            }) : new Headers({
              'content-type': 'application/json'
            });
            return _context3.abrupt("return", apiFetch(endpoint, {
              method: "DELETE",
              headers: headers
            }));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function deleteFetch(_x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();

var putFetch = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(endpoint, data, token) {
    var headers;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            headers = token ? new Headers({
              'content-type': 'application/json',
              'Authorization': 'Bearer ' + token
            }) : new Headers({
              'content-type': 'application/json'
            });
            return _context4.abrupt("return", apiFetch(endpoint, {
              method: 'PUT',
              headers: headers,
              body: JSON.stringify(data)
            }));

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function putFetch(_x9, _x10, _x11) {
    return _ref4.apply(this, arguments);
  };
}();

var apiFetch = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(endpoint, options) {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return fetch(endpoint, options).then(status).then(data);

          case 2:
            return _context5.abrupt("return", _context5.sent);

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function apiFetch(_x12, _x13) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 *
 * @returns {{data, loading, doFetch: (function(*=, *=): Promise<void>), errors}}
 */


var useDownloadFetch = function useDownloadFetch() {
  var _useReducer = useReducer(reducer$1, {
    error: undefined,
    loading: false,
    data: undefined
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var doFetch = useCallback( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(endpoint, options) {
      var fileName;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              dispatch({
                type: 'LOADING'
              });
              fileName = undefined;
              _context6.next = 4;
              return fetch(endpoint, options).then(status).then(function (res) {
                fileName = res.headers.get('content-disposition').split("filename=")[1];
                return res.blob();
              }).then(function (data) {
                data.fileName = fileName;
                dispatch({
                  type: 'DATA',
                  data: data
                });
              })["catch"](function (error) {
                try {
                  error.then(function (err) {
                    return dispatch({
                      type: 'ERROR',
                      error: JSON.parse(err)
                    });
                  });
                } catch (e) {
                  dispatch({
                    type: 'ERROR',
                    error: {
                      message: "Vous avez perdu la connexion avec le serveur.",
                      title: "Fetch error"
                    }
                  });
                }
              });

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x14, _x15) {
      return _ref6.apply(this, arguments);
    };
  }(), []);
  return {
    error: state.error,
    loading: state.loading,
    data: state.data,
    doFetch: doFetch
  };
};
/**
 *
 * @returns {{data, loading, doFetch: (function(*=, *=): Promise<void>), errors}}
 */


var useApiFetch = function useApiFetch() {
  var _useReducer3 = useReducer(reducer$1, {
    error: undefined,
    loading: false,
    data: undefined
  }),
      _useReducer4 = _slicedToArray(_useReducer3, 2),
      state = _useReducer4[0],
      dispatch = _useReducer4[1];

  var doFetch = useCallback( /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(endpoint, options) {
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              dispatch({
                type: 'LOADING'
              });
              apiFetch(endpoint, options).then(function (data) {
                return dispatch({
                  type: 'DATA',
                  data: data
                });
              })["catch"](function (error) {
                try {
                  error.then(function (err) {
                    return dispatch({
                      type: 'ERROR',
                      error: JSON.parse(err)
                    });
                  });
                } catch (e) {
                  dispatch({
                    type: 'ERROR',
                    error: {
                      message: "Vous avez perdu la connexion avec le serveur.",
                      title: "Fetch error"
                    }
                  });
                }
              });

            case 2:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x16, _x17) {
      return _ref7.apply(this, arguments);
    };
  }(), []);
  return {
    error: state.error,
    loading: state.loading,
    data: state.data,
    doFetch: doFetch
  };
};

function useIsMountedRef() {
  var isMountedRef = useRef(null);
  useEffect(function () {
    isMountedRef.current = true;
    return function () {
      return isMountedRef.current = false;
    };
  });
  return isMountedRef;
}

function useKeyPress(key, action, modifiers) {
  useEffect(function () {
    function onKeyUp(e) {
      if (e.key === key) action();
    }

    window.addEventListener('keyup', onKeyUp);
    return function () {
      return window.removeEventListener('keyup', onKeyUp);
    };
  }, []);
}
function useCtrlKeyPress(key, action) {
  useEffect(function () {
    function onCtrlKeyUp(e) {
      if (e.ctrlKey && e.key === key) action();
    }

    window.addEventListener('keyup', onCtrlKeyUp);
    return function () {
      return window.removeEventListener('keyup', onCtrlKeyUp);
    };
  }, []);
}

function useOutside(ref, callback) {
  useEffect(function () {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) ;
    }

    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
}

var _templateObject$t, _templateObject2$i, _templateObject3$d, _templateObject4$9, _templateObject5$7, _templateObject6$5;
var Container$9 = styled.div(_templateObject$t || (_templateObject$t = _taggedTemplateLiteral(["\n    display: none; /* Hidden by default */\n    position: fixed; /* Stay in place */\n    z-index: 1000;\n    left: 0;\n    top: 0;\n    width: 100%; /* Full width */\n    height: 100%; /* Full height */\n    overflow: auto; /* Enable scroll if needed */\n    background-color: rgba(0, 0, 0, 0); /* Black w/ opacity */\n\n    &.open {\n        background-color: rgba(0, 0, 0, 0.8); /* Black w/ opacity */\n        transition: background-color 0.1s linear;\n        display: block;\n    }\n"])));
var Content$5 = styled.div(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteral(["\n    width: 40%;\n    max-width: 60%;\n    margin: -1000px auto auto;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n    transition: all 0.3s;\n    position: relative;\n\n    &.open {\n        margin-top: 200px;\n        transition: margin-top 0.2s linear;\n    }\n\n    &:hover {\n        box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n    }\n"])));
var Header$1 = styled.header(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteral(["\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n    background-color: ", ";\n    border-bottom: 2px solid ", ";\n"])), function (props) {
  return props.theme.variables.borderRadius;
}, function (props) {
  return props.theme.variables.borderRadius;
}, function (props) {
  return props.theme.components.card.backgroundColor;
}, function (props) {
  return props.theme.scheme[props.variant].normal;
});
var Title$4 = styled.h1(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: 1.8rem;\n    padding: ", " ", ";\n    margin: 0;\n"])), function (props) {
  return props.theme.scheme[props.variant].normal;
}, space(3), space(4));
var Body$1 = styled.main(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteral(["\n    padding: ", ";\n    color: ", ";\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n    background-color: ", ";\n"])), space(4), function (props) {
  return props.theme.invertColor.normal;
}, function (props) {
  return !props.withFooter && props.theme.variables.borderRadius;
}, function (props) {
  return !props.withFooter && props.theme.variables.borderRadius;
}, function (props) {
  return !props.withTitle && props.theme.variables.borderRadius;
}, function (props) {
  return !props.withTitle && props.theme.variables.borderRadius;
}, function (props) {
  return props.theme.components.card.backgroundColor;
});
var Footer$1 = styled.footer(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n    padding: ", " ", ";\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n"])), function (props) {
  return props.theme.scheme[props.variant].normal;
}, function (props) {
  return props.theme.scheme[props.variant].color;
}, space(3), space(4), function (props) {
  return props.theme.variables.borderRadius;
}, function (props) {
  return props.theme.variables.borderRadius;
});
var Modal = function Modal(_ref) {
  var isOpened = _ref.isOpened,
      onClose = _ref.onClose,
      title = _ref.title,
      variant = _ref.variant,
      footer = _ref.footer,
      children = _ref.children;

  var _useContext = useContext(IconContext),
      close = _useContext.close;

  useKeyPress('Escape', function () {
    return onClose();
  });
  return /*#__PURE__*/jsxRuntime.jsx(Container$9, {
    open: isOpened,
    className: isOpened ? "open" : "",
    children: /*#__PURE__*/jsxRuntime.jsxs(Content$5, {
      className: isOpened ? "open" : "",
      children: [/*#__PURE__*/jsxRuntime.jsx(CloseButton$1, {
        variant: variant,
        onClick: function onClick() {
          return onClose();
        },
        children: close
      }), title && /*#__PURE__*/jsxRuntime.jsx(Header$1, {
        variant: variant,
        children: /*#__PURE__*/jsxRuntime.jsx(Title$4, {
          variant: variant,
          children: title
        })
      }), /*#__PURE__*/jsxRuntime.jsx(Body$1, {
        variant: variant,
        withTitle: title !== undefined,
        withFooter: footer !== undefined,
        children: children
      }), footer && /*#__PURE__*/jsxRuntime.jsx(Footer$1, {
        variant: variant,
        children: footer
      })]
    })
  });
};
Modal.propTypes = {
  variant: propTypes.oneOfType([propTypes.oneOf([Variant]), propTypes.string]),
  title: propTypes.string,
  footer: propTypes.oneOfType([propTypes.node, propTypes.string])
};
Modal.defaultProps = {
  variant: Variant.PRIMARY
};

var _templateObject$s, _templateObject2$h, _templateObject3$c, _templateObject4$8, _templateObject5$6, _templateObject6$4;
var RowHead = styled.tr(_templateObject$s || (_templateObject$s = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-bottom: 3px solid ", ";\n"])), function (props) {
  return props.theme.color.normal;
}, function (props) {
  return props.theme.scheme[props.variant].normal;
});
RowHead.propTypes = {
  variant: propTypes.oneOfType([propTypes.oneOf([Variant]), propTypes.string])
};
RowHead.defaultProps = {
  variant: Variant.PRIMARY
};
var CellHead = styled.th(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteral(["\n    padding: ", ";\n    line-height: 1.4;\n    font-size: 1.1rem;\n    color: ", ";\n    text-align: left;\n"])), space(3), function (props) {
  return props.theme.scheme[props.variant].normal;
});
CellHead.propTypes = {
  variant: propTypes.oneOfType([propTypes.oneOf([Variant]), propTypes.string])
};
CellHead.defaultProps = {
  variant: Variant.PRIMARY
};
var Row = styled.tr(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n    // border-bottom: 1px solid ", ";\n\n    &:nth-child(odd) {\n        background-color: ", ";\n    }\n\n    &:last-child {\n        border-bottom: none;\n    }\n"])), function (props) {
  return props.theme.color.normal;
}, function (props) {
  return props.theme.invertColor.normal;
}, function (props) {
  return props.theme.invertColor.light;
}, function (props) {
  return props.theme.color.light;
});
var Cell = styled.td(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteral(["\n    padding: ", " ", ";\n    line-height: 1.6rem;\n"])), space(2), space(3));
var TableStylized = styled.table(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteral(["\n    width: 100%;\n    border-collapse: collapse;\n"])));
var Container$8 = styled.div(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteral(["\n    border-radius: ", ";\n    box-shadow: ", ";\n    overflow: hidden;\n    padding: ", ";\n    background-color: ", ";\n"])), function (props) {
  return props.theme.variables.borderRadius;
}, function (props) {
  return props.theme.variables.shadow.normal;
}, space(3), function (props) {
  return props.theme.color.normal;
});

var Table = function Table(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/jsxRuntime.jsx(Container$8, {
    children: /*#__PURE__*/jsxRuntime.jsx(TableStylized, _objectSpread2(_objectSpread2({}, props), {}, {
      children: children
    }))
  });
};

Table.propTypes = {};

var _templateObject$r, _templateObject2$g, _templateObject3$b;
Pagination.propTypes = {
  totalElements: propTypes.number.isRequired,
  pageLimit: propTypes.number,
  pageNeighbours: propTypes.oneOf([0, 1, 2]),
  onPageChanged: propTypes.func.isRequired,
  rightIcon: propTypes.element,
  leftIcon: propTypes.element
};
Pagination.defaultProps = {
  pageLimit: 10,
  pageNeighbours: 0,
  rightIcon: /*#__PURE__*/jsxRuntime.jsx("span", {
    "aria-hidden": "true",
    children: "\xBB"
  }),
  leftIcon: /*#__PURE__*/jsxRuntime.jsx("span", {
    "aria-hidden": "true",
    children: "\xAB"
  })
};
var LEFT_PAGE = "LEFT";
var RIGHT_PAGE = "RIGHT";
/**
 * Helper method for creating a range of numbers
 * range(1, 5) => [1, 2, 3, 4, 5]
 * range(0, 10, 2) => [0, 2, 4, 6, 8, 10]
 * @param from
 * @param to
 * @param step
 * @returns {[]}
 */

var range = function range(from, to) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var i = from;
  var range = [];

  while (i <= to) {
    range.push(i);
    i += step;
  }

  return range;
};

var Nav = styled.nav(_templateObject$r || (_templateObject$r = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row-reverse;\n    margin: ", " 0;\n"])), space(2));
var Paginate = styled.ul(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteral(["\n    display: flex;\n    list-style: none;\n"])));
var Page = styled.li(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n    padding: ", ";\n    margin: 0 ", ";\n    min-width: 24px;\n    text-align: center;\n    border-radius: ", ";\n    cursor: pointer;\n    transition: all 0.2s linear;\n\n    &:hover {\n        transition: all 0.2s linear;\n        background-color: ", ";\n        color: ", ";\n    }\n"])), function (props) {
  return props.active ? props.theme.scheme[Variant.PRIMARY].normal : props.theme.color.normal;
}, function (props) {
  return props.active ? props.theme.scheme[Variant.PRIMARY].color : props.theme.color.color;
}, space(2), space(1), function (props) {
  return props.theme.variables.borderRadius;
}, function (props) {
  return props.theme.scheme[Variant.SECONDARY].normal;
}, function (props) {
  return props.theme.scheme[Variant.SECONDARY].color;
});
/**1
 * @return {JSX.Element}
 */

function Pagination(_ref) {
  var totalElements = _ref.totalElements,
      pageLimit = _ref.pageLimit,
      pageNeighbours = _ref.pageNeighbours,
      onPageChanged = _ref.onPageChanged,
      leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon;

  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      totalPages = _useState2[0],
      setTotalPages = _useState2[1];

  var _useState3 = useState(1),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  var gotoPage = function gotoPage(page) {
    return setCurrentPage(Math.max(0, Math.min(page, totalPages)));
  };

  useEffect(function () {
    gotoPage(1);
  }, []);
  useEffect(function () {
    onPageChanged({
      currentPage: currentPage,
      totalPages: totalPages,
      pageLimit: pageLimit,
      totalElements: totalElements
    });
  }, [currentPage]);
  useEffect(function () {
    setTotalPages(Math.ceil(totalElements / pageLimit));
  }, [pageLimit, totalElements]);
  if (!totalElements || totalPages === 1) return null;

  var handleClick = function handleClick(page) {
    return function (e) {
      e.preventDefault();
      gotoPage(page);
    };
  };

  var handleMoveLeft = function handleMoveLeft(e) {
    e.preventDefault();
    gotoPage(currentPage - 1);
  };

  var handleMoveRight = function handleMoveRight(e) {
    e.preventDefault();
    gotoPage(currentPage + 1);
  };

  var fetchPageNumbers = function fetchPageNumbers() {
    /**
     * totalNumbers: the total page numbers to show on the control.
     * totalBlocks: totalNumbers + 2 to cover for the left(<) and right(>) controls.
     */
    var totalNumbers = pageNeighbours * 2 + 3;
    var totalBlocks = totalNumbers + 2;

    if (totalPages > totalBlocks) {
      var startPage = Math.max(2, currentPage - pageNeighbours);
      var endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
      var pages = range(startPage, endPage);
      var hasLeftSpill = startPage > 2;
      var hasRightSpill = totalPages - endPage > 1;
      var spillOffset = totalNumbers - (pages.length + 1);

      switch (true) {
        // handle: (1) < {5 6} [7] {8 9} (10)
        case hasLeftSpill && !hasRightSpill:
          {
            var extraPages = range(startPage - spillOffset, startPage - 1);
            pages = [LEFT_PAGE].concat(_toConsumableArray(extraPages), _toConsumableArray(pages));
            break;
          }
        // handle: (1) {2 3} [4] {5 6} > (10)

        case !hasLeftSpill && hasRightSpill:
          {
            var _extraPages = range(endPage + 1, endPage + spillOffset);

            pages = [].concat(_toConsumableArray(pages), _toConsumableArray(_extraPages), [RIGHT_PAGE]);
            break;
          }
        // handle: (1) < {4 5} [6] {7 8} > (10)

        case hasLeftSpill && hasRightSpill:
        default:
          {
            pages = [LEFT_PAGE].concat(_toConsumableArray(pages), [RIGHT_PAGE]);
            break;
          }
      }

      return [1].concat(_toConsumableArray(pages), [totalPages]);
    }

    return range(1, totalPages);
  };

  return /*#__PURE__*/jsxRuntime.jsx(Nav, {
    "aria-label": "pagination",
    children: /*#__PURE__*/jsxRuntime.jsx(Paginate, {
      children: fetchPageNumbers().map(function (page, index) {
        if (page === LEFT_PAGE) return /*#__PURE__*/jsxRuntime.jsx(Page, {
          "aria-label": "Previous",
          onClick: handleMoveLeft,
          children: leftIcon
        }, index);
        if (page === RIGHT_PAGE) return /*#__PURE__*/jsxRuntime.jsx(Page, {
          "aria-label": "Next",
          onClick: handleMoveRight,
          children: rightIcon
        }, index);
        return /*#__PURE__*/jsxRuntime.jsx(Page, {
          active: currentPage === page,
          onClick: handleClick(page),
          children: page
        }, index);
      })
    })
  });
}

function rangeLevel(props, propName, componentName) {
  componentName = componentName || 'ANONYMOUS';

  if (props[propName]) {
    var value = props[propName];

    if (typeof value === 'number') {
      return value >= 1 && value <= 6 ? null : new Error(propName + ' in ' + componentName + " is not within ".concat(1, " to ", 6));
    }
  } // assume all ok


  return null;
}

var _templateObject$q, _templateObject2$f, _templateObject3$a, _templateObject4$7, _templateObject5$5, _templateObject6$3;
var H1 = styled.h1(_templateObject$q || (_templateObject$q = _taggedTemplateLiteral(["\n    line-height: 1.5;\n    font-weight: bolder;\n    font-size: 2.2rem;\n    color: ", ";\n\n    > svg {\n        width: 30px;\n        height: 30px;\n    }\n\n    @media only screen and (max-width: 480px) {\n        font-size: 2.1rem;\n    }\n"])), function (props) {
  return props.variant ? props.theme.scheme[props.variant].normal : props.theme.invertColor.normal;
});
var H2 = styled.h2(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteral(["\n    font-size: 1.8rem;\n    line-height: 1;\n    letter-spacing: 0;\n    margin: ", " 0;\n    color: ", ";\n\n    @media only screen and (max-width: 480px) {\n        font-size: 1.8rem;\n        margin-bottom: ", ";\n    }\n}"])), space(3), function (props) {
  return props.variant ? props.theme.scheme[props.variant].normal : props.theme.invertColor.normal;
}, space(2));
var H3 = styled.h3(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteral(["\n    font-size: 1.5rem;\n    text-transform: none;\n    color: ", ";\n"])), function (props) {
  return props.variant ? props.theme.scheme[props.variant].normal : props.theme.invertColor.normal;
});
var H4 = styled.h4(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteral(["\n    font-weight: bold;\n    font-size: 1.30rem;\n    color: ", ";\n"])), function (props) {
  return props.variant ? props.theme.scheme[props.variant].normal : props.theme.invertColor.normal;
});
var H5 = styled.h5(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteral(["\n    font-size: 1.25rem;\n    font-weight: lighter;\n    color: ", ";\n"])), function (props) {
  return props.variant ? props.theme.scheme[props.variant].normal : props.theme.invertColor.normal;
});
var H6 = styled.h6(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteral(["\n    font-size: 1.20rem;\n    font-style: italic;\n    color: ", ";\n"])), function (props) {
  return props.variant ? props.theme.scheme[props.variant].normal : props.theme.invertColor.normal;
});

var Title$3 = function Title(_ref) {
  var level = _ref.level,
      variant = _ref.variant,
      children = _ref.children;

  switch (level) {
    case 1:
      return /*#__PURE__*/jsxRuntime.jsx(H1, {
        variant: variant,
        children: children
      });

    case 2:
      return /*#__PURE__*/jsxRuntime.jsx(H2, {
        variant: variant,
        children: children
      });

    case 3:
      return /*#__PURE__*/jsxRuntime.jsx(H3, {
        variant: variant,
        children: children
      });

    case 4:
      return /*#__PURE__*/jsxRuntime.jsx(H4, {
        variant: variant,
        children: children
      });

    case 5:
      return /*#__PURE__*/jsxRuntime.jsx(H5, {
        variant: variant,
        children: children
      });

    case 6:
      return /*#__PURE__*/jsxRuntime.jsx(H6, {
        variant: variant,
        children: children
      });
  }
};

Title$3.propTypes = {
  level: rangeLevel,
  variant: propTypes.oneOfType([propTypes.oneOf([Variant]), propTypes.string])
};
Title$3.defaultProps = {
  level: 1
};

var _templateObject$p;
var HyperLink = styled.a(_templateObject$p || (_templateObject$p = _taggedTemplateLiteral(["\n    text-decoration: none;\n    color: ", ";\n    transition: all .2s linear;\n    font-weight: bold;\n    outline: none;\n\n    &:hover, &:active, &:focus {\n      transition: all .2s linear;\n      color: ", ";\n    }\n"])), function (props) {
  return props.theme.scheme.primary.normal;
}, function (props) {
  return props.theme.scheme.secondary.normal;
});

var _templateObject$o;
var Pin = styled.span(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral(["\n    padding: ", ";\n    background-color: ", ";\n    color: ", ";\n    font-size: 0.9rem;\n    border-radius: ", ";\n"])), space(1), function (props) {
  return props.theme.scheme[props.variant].normal;
}, function (props) {
  return props.theme.scheme[props.variant].color;
}, function (props) {
  return props.theme.variables.borderRadius;
});
Pin.propTypes = {
  variant: propTypes.oneOfType([propTypes.oneOf([Variant]), propTypes.string])
};
Pin.defaultProps = {
  variant: Variant.PRIMARY
};

var _templateObject$n, _templateObject2$e, _templateObject3$9, _templateObject4$6;
var CheckboxRow = styled.div(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin: ", ";\n"])), space(1));
var CheckboxStyled = styled.div(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  padding-left: 35px;\n  cursor: pointer;\n  font-size: 1em;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n\n  label {\n    color: ", ";\n    margin-right: ", ";\n\n    &:hover {\n      cursor: ", ";\n    }\n  }\n\n  input {\n      position: absolute;\n      opacity: 0;\n      cursor: pointer;\n      height: 0;\n      width: 0;\n\n    &:checked ~ span {\n      background-color: ", ";\n    }\n    &:checked ~ span:after {\n      display: block;\n    }\n\n    &:hover ~ span {\n      background-color: ", ";\n      cursor: ", ";\n    }\n  }\n"])), function (props) {
  return props.disabled && props.theme.scheme[Variant.LIGHT].normal;
}, space(2), function (props) {
  return props.disabled ? "default" : "pointer";
}, function (props) {
  return props.theme.scheme[Variant.PRIMARY].normal;
}, function (props) {
  return !props.disabled && props.theme.scheme[Variant.SECONDARY].normal;
}, function (props) {
  return props.disabled ? "default" : "pointer";
});
var Checkmark$1 = styled.span(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 25px;\n  width: 25px;\n  background-color: ", ";\n  transition: all 0.2s linear;\n\n  &:hover {\n    background-color: ", ";\n    cursor: ", ";\n  }\n\n  &:after {\n      content: \"\";\n      position: absolute;\n      display: none;\n      left: 9px;\n      top: 5px;\n      width: 5px;\n      height: 10px;\n      border: solid white;\n      border-width: 0 3px 3px 0;\n      -webkit-transform: rotate(45deg);\n      -ms-transform: rotate(45deg);\n      transform: rotate(45deg);\n  }\n"])), function (props) {
  return props.disabled ? props.theme.scheme[Variant.LIGHT].normal : props.theme.scheme[Variant.LIGHT].dark;
}, function (props) {
  return !props.disabled && props.theme.scheme[Variant.PRIMARY].dark;
}, function (props) {
  return !props.disabled && "pointer";
});
var Content$4 = styled.div(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral(["\n  display: flex;\n  padding: ", ";\n"])), space(1));
var Checkbox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var name = _ref.name,
      label = _ref.label,
      disabled = _ref.disabled,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["name", "label", "disabled", "children"]);

  return /*#__PURE__*/jsxRuntime.jsx(CheckboxStyled, {
    disabled: disabled,
    children: /*#__PURE__*/jsxRuntime.jsxs(Content$4, {
      children: [/*#__PURE__*/jsxRuntime.jsxs("label", {
        children: [label, /*#__PURE__*/jsxRuntime.jsx("input", _objectSpread2({
          type: "checkbox",
          name: name,
          ref: ref,
          disabled: disabled
        }, props)), /*#__PURE__*/jsxRuntime.jsx(Checkmark$1, {
          disabled: disabled
        })]
      }), children]
    })
  });
});
Checkbox.propTypes = {
  name: propTypes.string.isRequired,
  label: propTypes.oneOfType([propTypes.string, propTypes.element]).isRequired,
  disabled: propTypes.bool
};
Checkbox.defaultProps = {
  disabled: false
};

var _templateObject$m, _templateObject2$d, _templateObject3$8, _templateObject4$5, _templateObject5$4, _templateObject6$2, _templateObject7$1, _templateObject8$1;
var PhoneInputStylised = styled.div(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral(["\n    margin: ", " 0;\n\n    .form-control {\n        width: 100%;\n        padding: ", ";\n        margin: ", " 0;\n        box-sizing: border-box;\n        transition: all 0.3s;\n        min-height: ", "px;\n        max-height: ", "px;\n        border: 2px solid ", ";\n        border-radius: ", ";\n        outline: none;\n\n        &:focus {\n            background-color: ", ";\n            border-color: ", ";\n        }\n    }\n\n    small {\n        color: ", ";\n    }\n"])), space(2), space(3), space(1), function (props) {
  return props.theme.input.height + 20;
}, function (props) {
  return props.theme.input.height + 20;
}, function (props) {
  return props.error ? props.theme.scheme[Variant.DANGER].normal : props.theme.scheme[Variant.LIGHT].normal;
}, space(1), function (props) {
  return props.theme.scheme[Variant.PRIMARY].light;
}, function (props) {
  return props.theme.scheme[Variant.PRIMARY].normal;
}, function (props) {
  return props.theme.scheme[Variant.DANGER].normal;
});
var InputWrapper = styled.div(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral(["\n    margin: ", " 0;\n\n    label {\n        display: block;\n    }\n\n    small {\n        color: ", ";\n    }\n"])), space(2), function (props) {
  return props.theme.scheme[Variant.DANGER].normal;
});
var InputContainer = styled.div(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral(["\n    padding: ", ";\n    margin: ", " 0;\n    transition: all 0.3s;\n    min-height: ", ";\n    max-height: ", ";\n    border-width: 2px;\n    border-style: solid;\n    border-radius: ", ";\n    border-color: ", ";\n    line-height: ", ";\n    display: flex;\n    align-items: center;\n    flex-direction: ", ";\n    background-color: ", ";\n\n    &:focus-within {\n        background-color: ", ";\n        border-color: ", ";\n    }\n"])), space(2), space(1), function (props) {
  return props.theme.components.input.height;
}, function (props) {
  return props.theme.components.input.height;
}, function (props) {
  return props.theme.variables.borderRadius;
}, function (props) {
  return props.error ? props.theme.scheme[Variant.DANGER].normal : props.theme.components.input.borderColor;
}, function (props) {
  return props.theme.components.input.lineHeight;
}, function (props) {
  return props.iconAlign === "right" ? "row-reverse" : "row";
}, function (props) {
  return props.disabled ? props.theme.scheme[Variant.LIGHT].normal : props.theme.components.input.backgroundColor;
}, function (props) {
  return props.error ? props.theme.scheme[Variant.DANGER].light : props.theme.scheme[Variant.PRIMARY].light;
}, function (props) {
  return props.error ? props.theme.scheme[Variant.DANGER].normal : props.theme.scheme[Variant.PRIMARY].normal;
});
var InputIcon = styled.div(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    color: ", ";\n    cursor: pointer;\n    transition: all 0.2s linear;\n\n    > * {\n        height: ", ";\n        width: ", ";\n    }\n\n    &:hover {\n        color: ", ";\n        transition: all 0.2s linear;\n    }\n"])), function (props) {
  return props.disabled ? props.theme.scheme[Variant.LIGHT].dark : props.error ? props.theme.scheme[Variant.DANGER].normal : props.focused ? props.theme.scheme[Variant.PRIMARY].normal : props.theme.scheme[Variant.DARK].normal;
}, function (props) {
  return props.theme.components.input.height;
}, function (props) {
  return props.theme.components.input.height;
}, function (props) {
  return props.theme.scheme[Variant.DARK].dark;
});
var ActionButton = styled.div(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    color: ", ";\n    transition: all 0.2s linear;\n\n    > * {\n        height: ", ";\n        width: ", ";\n    }\n\n    &:hover {\n        color: ", ";\n        transition: all 0.2s linear;\n    }\n"])), function (props) {
  return props.variant ? props.theme.scheme[props.variant].normal : props.theme.scheme[Variant.LIGHT].dark;
}, function (props) {
  return props.theme.components.input.height;
}, function (props) {
  return props.theme.components.input.height;
}, function (props) {
  return props.variant ? props.theme.scheme[props.variant].dark : props.theme.scheme[Variant.DARK].normal;
});
var PasswordButton = styled(ActionButton)(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral(["\n    color: ", ";\n"])), function (props) {
  return props.show ? props.theme.scheme[Variant.DARK].dark : props.theme.scheme[Variant.LIGHT].dark;
});
var InputStylised = styled.input(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    outline: none;\n    box-shadow: none;\n    border-color: transparent;\n    background: transparent;\n    margin: 0;\n    text-indent: ", ";\n\n    &[type=text], &[type=text]:focus {\n        outline: none !important;\n        outline-offset: 0 !important;\n    }\n\n    ::placeholder {\n        color: ", ";\n        opacity: 1;\n    }\n"])), space(2), function (props) {
  return props.disabled ? props.theme.scheme[Variant.LIGHT].dark : props.theme.scheme[Variant.LIGHT].dark;
});
var Label$2 = styled.label(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n    color: ", ";\n\n    &:hover {\n        cursor: pointer;\n    }\n"])), function (props) {
  return props.theme.color;
});
var initialState = {
  showPasswordBtn: false,
  showClearBtn: false,
  focused: false
};

function reducer(state, action) {
  switch (action.type) {
    case "togglePasswordBtn":
      return _objectSpread2(_objectSpread2({}, state), {}, {
        showPasswordBtn: !state.showPasswordBtn
      });

    case "toggleClearBtn":
      return _objectSpread2(_objectSpread2({}, state), {}, {
        showClearBtn: action.payload ? action.payload : !state.showClearBtn
      });

    case "toggleFocused":
      return _objectSpread2(_objectSpread2({}, state), {}, {
        focused: !state.focused
      });

    default:
      {
        throw new Error();
      }
  }
}

var Input = /*#__PURE__*/forwardRef(function (_ref, _ref2) {
  var label = _ref.label,
      icon = _ref.icon,
      iconAlign = _ref.iconAlign,
      actionBtn = _ref.actionBtn,
      clearBtn = _ref.clearBtn,
      required = _ref.required,
      error = _ref.error,
      type = _ref.type,
      clearIcon = _ref.clearIcon,
      showPasswordIcon = _ref.showPasswordIcon,
      hidePasswordIcon = _ref.hidePasswordIcon,
      props = _objectWithoutProperties(_ref, ["label", "icon", "iconAlign", "actionBtn", "clearBtn", "required", "error", "type", "clearIcon", "showPasswordIcon", "hidePasswordIcon"]);

  var _useReducer = useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var focused = state.focused,
      showClearBtn = state.showClearBtn,
      showPasswordBtn = state.showPasswordBtn;

  var _useState = useState(type),
      _useState2 = _slicedToArray(_useState, 2),
      inputType = _useState2[0],
      setInputType = _useState2[1];

  var inputRef = useRef();
  useEffect(function () {
    if (type === "password") setInputType(showPasswordBtn ? "text" : "password");
  }, [showPasswordBtn]);

  var focusInput = function focusInput() {
    return inputRef.current.focus();
  };

  var clearInput = function clearInput() {
    inputRef.value = '';
    dispatch({
      type: "toggleClearBtn"
    });
  };

  var toggleShowHidePassword = function toggleShowHidePassword() {
    inputRef.current.focus();
    dispatch({
      type: "togglePasswordBtn"
    });
  };

  var handleChange = function handleChange(e) {
    return dispatch({
      type: "toggleClearBtn",
      payload: e.target.value !== ''
    });
  };

  var _onFocus = function onFocus(focused) {
    return dispatch({
      type: "toggleFocused",
      payload: focused
    });
  };

  return /*#__PURE__*/jsxRuntime.jsxs(InputWrapper, {
    children: [label && /*#__PURE__*/jsxRuntime.jsx(Label$2, {
      onClick: focusInput,
      children: "".concat(label, " ").concat(required ? "*" : "")
    }), /*#__PURE__*/jsxRuntime.jsxs(InputContainer, _objectSpread2(_objectSpread2({
      error: error
    }, props), {}, {
      onClick: focusInput,
      iconAlign: iconAlign,
      children: [icon && /*#__PURE__*/jsxRuntime.jsx(InputIcon, _objectSpread2(_objectSpread2({
        onClick: focusInput,
        focused: focused,
        error: error
      }, props), {}, {
        children: icon
      })), /*#__PURE__*/jsxRuntime.jsx(InputStylised, _objectSpread2(_objectSpread2({}, props), {}, {
        ref: function ref(e) {
          if (typeof _ref2 === "function") _ref2(e);
          inputRef.current = e;
        },
        type: inputType,
        onChange: handleChange,
        onFocus: function onFocus() {
          return _onFocus(true);
        },
        onBlur: function onBlur() {
          return _onFocus(false);
        }
      })), clearBtn && showClearBtn && /*#__PURE__*/jsxRuntime.jsx(ActionButton, {
        onClick: clearInput,
        children: clearIcon
      }), actionBtn && /*#__PURE__*/jsxRuntime.jsx(ActionButton, {
        children: actionBtn
      }), type === "password" && /*#__PURE__*/jsxRuntime.jsx(PasswordButton, {
        onClick: toggleShowHidePassword,
        children: showPasswordBtn ? hidePasswordIcon : showPasswordIcon
      })]
    })), error && /*#__PURE__*/jsxRuntime.jsx("small", {
      children: error
    })]
  });
});
Input.propTypes = {
  label: propTypes.string,
  icon: propTypes.element,
  iconAlign: propTypes.oneOf(["right", "left"]),
  clearBtn: propTypes.bool,
  required: propTypes.bool,
  error: propTypes.oneOfType([propTypes.string, propTypes.element]),
  type: propTypes.string,
  clearIcon: propTypes.element,
  showPasswordIcon: propTypes.element,
  hidePasswordIcon: propTypes.element
};
Input.defaultProps = {
  type: "text",
  iconAlign: "left",
  required: false,
  clearBtn: false
};

var _templateObject$l, _templateObject2$c, _templateObject3$7, _templateObject4$4, _templateObject5$3;
var RadioRow = styled.div(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    margin: ", ";\n"])), space(1));
var Content$3 = styled.div(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral(["\n    display: flex;\n    padding: ", ";\n"])), space(1));
var Label$1 = styled.label(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral(["\n    color: ", ";\n"])), function (props) {
  return props.theme.color;
});
var Container$7 = styled.div(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral(["\n    display: flex;\n    position: relative;\n    padding-left: 35px;\n    cursor: pointer;\n    font-size: 1em;\n    margin: ", "px 0;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n\n    label {\n        color: ", ";\n        margin-right: ", ";\n\n        &:hover {\n            cursor: ", ";\n        }\n    }\n\n    input {\n        position: absolute;\n        opacity: 0;\n        cursor: pointer;\n        height: 0;\n        width: 0;\n\n        &:checked ~ span {\n            background-color: ", ";\n        }\n\n        &:checked ~ span:after {\n            display: block;\n        }\n\n        &:hover ~ span {\n            border-color: ", ";\n            cursor: ", ";\n            transition: all 0.2s linear;\n\n            &:after {\n                background-color: ", ";\n                transition: all 0.2s linear;\n            }\n        }\n    }\n"])), function (props) {
  return level(1) * props.gap;
}, function (props) {
  return props.disabled && color(Variant.LIGHT).normal;
}, space(2), function (props) {
  return props.disabled ? "default" : "pointer";
}, color(Variant.LIGHT).normal, function (props) {
  return !props.disabled && color(Variant.PRIMARY).normal;
}, function (props) {
  return props.disabled ? "default" : "pointer";
}, color(Variant.DARK).light);
var Checkmark = styled.span(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 20px;\n    width: 20px;\n    border-radius: 50%;\n    border: 2px solid ", ";\n    background-color: ", ";\n    transition: all 0.2s linear;\n\n    &:hover {\n        border-color: ", ";\n        cursor: ", ";\n    }\n\n    &:after {\n        content: \"\";\n        position: absolute;\n        display: none;\n        top: 4px;\n        left: 4px;\n        width: 12px;\n        height: 12px;\n        border-radius: 50%;\n        background-color: ", ";\n    }\n"])), function (props) {
  return props.disabled ? color(Variant.LIGHT).normal : color(Variant.LIGHT).dark;
}, color(Variant.LIGHT).light, function (props) {
  return !props.disabled && color(Variant.PRIMARY).dark;
}, function (props) {
  return !props.disabled && "pointer";
}, color(Variant.PRIMARY).normal);
var Radio = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var name = _ref.name,
      label = _ref.label,
      value = _ref.value,
      disabled = _ref.disabled,
      checked = _ref.checked,
      gap = _ref.gap,
      props = _objectWithoutProperties(_ref, ["name", "label", "value", "disabled", "checked", "gap"]);

  return /*#__PURE__*/jsxRuntime.jsx(Container$7, {
    disabled: disabled,
    gap: gap,
    children: /*#__PURE__*/jsxRuntime.jsx(Content$3, {
      children: /*#__PURE__*/jsxRuntime.jsxs(Label$1, {
        children: [label, /*#__PURE__*/jsxRuntime.jsx("input", _objectSpread2({
          type: "radio",
          name: name,
          value: value,
          ref: ref,
          defaultChecked: checked
        }, props)), /*#__PURE__*/jsxRuntime.jsx(Checkmark, {
          disabled: disabled
        })]
      })
    })
  });
});
Radio.propTypes = {
  checked: propTypes.bool,
  name: propTypes.string.isRequired,
  label: propTypes.oneOfType([propTypes.string, propTypes.node]),
  value: propTypes.oneOfType([propTypes.string, propTypes.number]),
  disabled: propTypes.bool,
  gap: rangeLevel
};
Radio.defaultProps = {
  checked: false,
  gap: 1
};

var _templateObject$k, _templateObject2$b;
var Container$6 = styled.div(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n    margin: ", " 0;\n\n    label {\n        display: block;\n    }\n\n    small {\n        color: ", ";\n    }\n"])), space(2), function (props) {
  return props.theme.scheme[Variant.DANGER].normal;
});
var SelectStylised = styled.select(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n    width: 100%;\n    padding: ", " ", ";\n    margin: ", " 0;\n    box-sizing: border-box;\n    transition: all 0.3s;\n    min-height: ", ";\n    max-height: ", ";\n    border: 2px solid ", ";\n    border-radius: ", ";\n    line-height: ", ";\n    max-width: 100%;\n    //appearance: none;\n    outline: none;\n    color: ", ";\n    background-color: ", ";\n\n    &.error {\n        background-color: ", ";\n        border-color: ", ";\n    }\n\n    &:focus {\n        background-color: ", ";\n        border-color: ", ";\n    }\n\n    option {\n        background-color: white;\n        padding: ", ";\n\n        &:first-child {\n            color: ", ";\n        }\n    }\n"])), space(2), space(3), space(1), function (props) {
  return props.theme.components.select.height;
}, function (props) {
  return props.theme.components.select.height;
}, function (props) {
  return props.theme.scheme[Variant.LIGHT].normal;
}, space(1), function (props) {
  return props.theme.components.select.lineHeight;
}, function (props) {
  return props.theme.color.normal;
}, function (props) {
  return props.disabled ? props.theme.scheme[Variant.LIGHT].normal : props.theme.components.input.backgroundColor;
}, function (props) {
  return props.theme.scheme[Variant.DANGER].light;
}, function (props) {
  return props.theme.scheme[Variant.DANGER].normal;
}, function (props) {
  return props.theme.scheme[Variant.PRIMARY].light;
}, function (props) {
  return props.theme.scheme[Variant.PRIMARY].normal;
}, space(2), function (props) {
  return props.firstOption && props.theme.scheme[Variant.LIGHT].dark;
});
var Select = /*#__PURE__*/forwardRef(function (_ref, _ref2) {
  var name = _ref.name,
      label = _ref.label,
      options = _ref.options;
      _ref.register;
      var error = _ref.error,
      firstOption = _ref.firstOption,
      firstText = _ref.firstText,
      props = _objectWithoutProperties(_ref, ["name", "label", "options", "register", "error", "firstOption", "firstText"]);

  return /*#__PURE__*/jsxRuntime.jsxs(Container$6, {
    children: [/*#__PURE__*/jsxRuntime.jsx("label", {
      children: label
    }), /*#__PURE__*/jsxRuntime.jsxs(SelectStylised, _objectSpread2(_objectSpread2({
      name: name,
      ref: function ref(e) {
        return _ref2(e);
      },
      className: error ? "error" : "",
      defaultValue: firstOption && firstText
    }, props), {}, {
      children: [firstOption && /*#__PURE__*/jsxRuntime.jsx("option", {
        value: undefined,
        disabled: true,
        children: firstText
      }), options]
    })), error && /*#__PURE__*/jsxRuntime.jsx("small", {
      children: error
    })]
  });
});
Select.propTypes = {
  name: propTypes.string.isRequired,
  label: propTypes.string,
  options: propTypes.array,
  firstOption: propTypes.bool
};
Select.defaultProps = {
  firstOption: false
};

var _templateObject$j;
var TextArea = styled.textarea(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 120px;\n    resize: vertical;\n    padding: ", ";\n    box-sizing: border-box;\n    border: 2px solid ", ";\n    border-radius: space(1);\n\n    &:focus {\n        background-color: ", ";\n        border: 2px solid ", ";;\n    }\n"])), space(3), color(Variant.LIGHT).normal, color(Variant.PRIMARY).light, color(Variant.PRIMARY).normal);

var _templateObject$i, _templateObject2$a, _templateObject3$6, _templateObject4$3, _templateObject5$2, _templateObject6$1;
var Container$5 = styled.div(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n    transition: all 0.3s;\n    background-color: ", ";\n\n    &:hover {\n        box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n        color: ", ";\n        cursor: ", ";\n    }\n"])), function (props) {
  return props.theme.components.card.backgroundColor;
}, function (props) {
  return props.onClick && "white";
}, function (props) {
  return props.onClick && "pointer";
});
var Body = styled.div(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral(["\n    color: ", ";\n    padding: ", " ", ";\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n    border-top: 2px solid ", ";\n    border-top-width: ", ";\n"])), function (props) {
  return props.theme.invertColor.normal;
}, space(3), space(4), function (props) {
  return !props.withFooter && props.theme.variables.borderRadius;
}, function (props) {
  return !props.withFooter && props.theme.variables.borderRadius;
}, function (props) {
  return props.withTitle && props.theme.variables.borderRadius;
}, function (props) {
  return props.withTitle && props.theme.variables.borderRadius;
}, function (props) {
  return props.theme.scheme[props.variant].normal;
}, function (props) {
  return props.withTitle ? "0px" : "2px";
});
var Header = styled.header(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["\n    border-top-left-radius: ", ";\n    border-top-right-radius: ", ";\n    background-color: ", ";\n    padding: ", " ", ";\n"])), function (props) {
  return props.theme.variables.borderRadius;
}, function (props) {
  return props.theme.variables.borderRadius;
}, function (props) {
  return props.theme.components.card.backgroundColor;
}, space(3), space(4));
var Title$2 = styled.h1(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: 1.4rem;\n    font-weight: 400;\n    margin: 0;\n"])), function (props) {
  return props.theme.scheme[props.variant].normal;
});
var Subtitle$1 = styled.h2(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n    color: ", ";\n    font-size: 1.2rem;\n    font-weight: 300;\n    margin: 0;\n"])), function (props) {
  return props.theme.scheme[props.variant].normal;
});
var Footer = styled.footer(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n    padding: ", " ", ";\n    border-bottom-left-radius: ", ";\n    border-bottom-right-radius: ", ";\n"])), function (props) {
  return props.theme.color.dark;
}, function (props) {
  return props.theme.color.color;
}, space(2), space(4), function (props) {
  return props.theme.variables.borderRadius;
}, function (props) {
  return props.theme.variables.borderRadius;
});
function Card(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      footer = _ref.footer,
      children = _ref.children,
      onClick = _ref.onClick,
      variant = _ref.variant;
  return /*#__PURE__*/jsxRuntime.jsxs(Container$5, {
    children: [(title || subtitle) && /*#__PURE__*/jsxRuntime.jsxs(Header, {
      children: [title && /*#__PURE__*/jsxRuntime.jsx(Title$2, {
        variant: variant,
        children: title
      }), subtitle && /*#__PURE__*/jsxRuntime.jsx(Subtitle$1, {
        variant: variant,
        children: subtitle
      })]
    }), /*#__PURE__*/jsxRuntime.jsx(Body, {
      onClick: onClick,
      variant: variant,
      withTitle: title === undefined,
      withFooter: footer === undefined,
      children: children
    }), footer && /*#__PURE__*/jsxRuntime.jsx(Footer, {
      variant: variant,
      children: footer
    })]
  });
}
Card.propTypes = {
  onClick: propTypes.func,
  variant: propTypes.oneOfType([propTypes.oneOf([Variant]), propTypes.string]),
  footer: propTypes.node
};
Card.defaultProps = {
  variant: Variant.PRIMARY
};

var _templateObject$h;
var Container$4 = styled.div(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n    margin-right: auto;\n    margin-left: auto;\n    padding-left: 15px;\n    padding-right: 15px;\n    display: grid;\n    align-items: center;\n\n    @media ", " {\n      width: 750px;\n    }\n    @media ", " {\n      width: 970px;\n    }\n    @media ", " {\n      width: 1170px;\n    }\n"])), Device.TABLET, Device.LAPTOP, Device.LAPTOP_L);

var _templateObject$g;
var Grid = styled.section(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: repeat(", ", 1fr);\n    grid-template-rows: repeat(", ", 1fr);\n    grid-gap: ", ";\n    align-items: start;\n\n    @media only screen and (max-width: 900px) {\n        grid-template-columns: 1fr;\n        grid-gap: ", ";\n    }\n"])), function (props) {
  return props.columns;
}, function (props) {
  return props.rows;
}, function (props) {
  return space(props.gap);
}, space(0));
Grid.propTypes = {
  columns: propTypes.number.isRequired,
  rows: propTypes.number.isRequired,
  gap: propTypes.oneOf([0, 1, 2, 3, 4, 5])
};
Grid.defaultProps = {
  columns: 1,
  rows: 1,
  gap: 1
};

var _templateObject$f;
var Section = styled.section(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n    margin: ", " 0;\n    padding: ", ";\n    height: 100%;\n"])), space(3), space(2));

var _templateObject$e, _templateObject2$9;
var Container$3 = styled.nav(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n    background-color: ", ";\n    background-color: ", ";\n    display: flex;\n    align-items: center;\n    height: ", ";\n    width: 100%;\n"])), function (props) {
  return props.theme.color.normal;
}, function (props) {
  return props.theme.color.dark;
}, function (props) {
  return props.theme.components.topBar.height;
});
var Brand = styled.div(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n    padding: 0 ", ";\n    font-weight: bolder;\n    font-size: 1.2rem;\n    color: ", ";\n    letter-spacing: 0.5px;\n    font-family: Montserrat, monospace;\n"])), space(3), function (props) {
  return props.theme.invertColor.normal;
});
function TopBar$1(_ref) {
  var brand = _ref.brand,
      children = _ref.children;
  return /*#__PURE__*/jsxRuntime.jsxs(Container$3, {
    children: [brand && /*#__PURE__*/jsxRuntime.jsx(Brand, {
      children: brand
    }), children]
  });
}

var _templateObject$d;
var Whitespace = styled.aside(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n    height: ", "px;\n    width: 100%;\n"])), function (props) {
  return props.level * level(props.small ? 2 : 5);
});
Whitespace.propTypes = {
  level: rangeLevel,
  small: propTypes.bool
};
Whitespace.defaultProps = {
  level: 1,
  small: false
};

var _templateObject$c, _templateObject2$8, _templateObject3$5;
var GrowElement$1 = styled.div(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n    flex-grow: ", ";\n"])), function (props) {
  return props.level;
});
GrowElement$1.propTypes = {
  level: rangeLevel
};
GrowElement$1.defaultProps = {
  level: 1
};
var Flex = styled.div(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: ", ";\n    align-items: ", ";\n"])), function (props) {
  return props.align === "right" ? "flex-end" : props.align === "center" ? "center" : "flex-start";
}, function (props) {
  return props.justifyItems;
});
Flex.propTypes = {
  align: propTypes.oneOf(["right", "center", "left"]).isRequired,
  justifyItems: propTypes.oneOf(["center"]).isRequired
};
Flex.defaultProps = {
  align: "left",
  justifyItems: "center"
};
var Column = styled(Flex)(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n    flex-direction: column;\n"])));

var _templateObject$b;
var Fade = styled.div(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n    animation: ", " ease ", "s;\n    -webkit-animation: ", " ease ", "s;\n    -moz-animation: ", " ease ", "s;\n    -o-animation: ", " ease ", "s;\n    -ms-animation: ", " ease ", "s;\n\n    @keyframes fadeIn {\n        0% {\n            opacity: 0;\n        }\n        100% {\n            opacity: 1;\n        }\n    }\n\n    @-moz-keyframes fadeIn {\n        0% {\n            opacity: 0;\n        }\n        100% {\n            opacity: 1;\n        }\n    }\n\n    @-webkit-keyframes fadeIn {\n        0% {\n            opacity: 0;\n        }\n        100% {\n            opacity: 1;\n        }\n    }\n\n    @-o-keyframes fadeIn {\n        0% {\n            opacity: 0;\n        }\n        100% {\n            opacity: 1;\n        }\n    }\n\n    @-ms-keyframes fadeIn {\n        0% {\n            opacity: 0;\n        }\n        100% {\n            opacity: 1;\n        }\n    }\n\n    @keyframes fadeOut {\n        0% {\n            opacity: 1;\n        }\n        100% {\n            opacity: 0;\n        }\n    }\n\n    @-moz-keyframes fadeOut {\n        0% {\n            opacity: 1;\n        }\n        100% {\n            opacity: 0;\n        }\n    }\n\n    @-webkit-keyframes fadeOut {\n        0% {\n            opacity: 1;\n        }\n        100% {\n            opacity: 0;\n        }\n    }\n\n    @-o-keyframes fadeOut {\n        0% {\n            opacity: 1;\n        }\n        100% {\n            opacity: 0;\n        }\n    }\n\n    @-ms-keyframes fadeOut {\n        0% {\n            opacity: 1;\n        }\n        100% {\n            opacity: 0;\n        }\n"])), function (props) {
  return props.open ? "fadeIn" : "fadeOut";
}, function (props) {
  return props.duration;
}, function (props) {
  return props.open ? "fadeIn" : "fadeOut";
}, function (props) {
  return props.duration;
}, function (props) {
  return props.open ? "fadeIn" : "fadeOut";
}, function (props) {
  return props.duration;
}, function (props) {
  return props.open ? "fadeIn" : "fadeOut";
}, function (props) {
  return props.duration;
}, function (props) {
  return props.open ? "fadeIn" : "fadeOut";
}, function (props) {
  return props.duration;
});
Fade.propTypes = {
  duration: propTypes.number,
  inAnimation: propTypes.bool,
  outAnimation: propTypes.bool,
  open: propTypes.bool
};
Fade.defaultProps = {
  open: true,
  duration: 0.3,
  inAnimation: true,
  outAnimation: true
};

var _templateObject$a, _templateObject2$7, _templateObject3$4;
var Title$1 = styled(H3)(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n    color: ", ";\n    border-bottom: 1px solid ", ";\n    padding-bottom: ", ";\n"])), function (props) {
  return props.theme.scheme[props.variant].normal;
}, function (props) {
  return props.theme.scheme[props.variant].normal;
}, space(2));
var Content$2 = styled.div(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n    margin-top: ", ";\n"])), space(1));
var Container$2 = styled.aside(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n"])));
var Menu = function Menu(_ref) {
  var iconTitle = _ref.iconTitle,
      title = _ref.title,
      items = _ref.items,
      variant = _ref.variant;
  return /*#__PURE__*/jsxRuntime.jsxs(Container$2, {
    children: [/*#__PURE__*/jsxRuntime.jsxs(Title$1, {
      variant: variant,
      children: [iconTitle, " ", title]
    }), /*#__PURE__*/jsxRuntime.jsx(Content$2, {
      children: items.map(function (item, index) {
        return /*#__PURE__*/f$1.cloneElement(item, {
          variant: variant
        });
      })
    })]
  });
};
Menu.propTypes = {
  title: propTypes.oneOfType([propTypes.string, propTypes.node]),
  items: propTypes.oneOfType([propTypes.any, propTypes.arrayOf(propTypes.instanceOf(MenuItem))]),
  variant: propTypes.string
};
Menu.defaultProps = {
  variant: Variant.PRIMARY
};

var _templateObject$9, _templateObject2$6, _templateObject3$3, _templateObject4$2, _templateObject5$1;
var Wrapper$1 = styled(Fade)(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n    z-index: 2;\n    position: absolute;\n    left: 0;\n    top: ", ";\n    right: 0;\n    bottom: 0;\n    background-color: ", ";\n    color: ", ";\n    font-family: 'Roboto', sans-serif;\n"])), function (props) {
  return props.top;
}, function (props) {
  return props.theme.color.dark;
}, function (props) {
  return props.theme.invertColor.normal;
});
var TopBar = styled(Flex)(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n    margin: ", ";\n"])), space(3));
var GrowElement = styled(H1)(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n    flex-grow: 1;\n    color: ", ";\n    margin: 0;\n    padding: 0;\n    line-height: 1;\n"])), function (props) {
  return props.theme.invertColor.normal;
});
var Content$1 = styled(Container$4)(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n    margin-top: ", ";\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    padding: ", ";\n    align-items: start;\n    grid-gap: ", ";\n"])), space(5), space(3), space(5));
var CloseButton = styled.a(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n    position: relative;\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n    background: ", ";\n    border-radius: 5px;\n    transition: all .3s ease-out;\n    cursor: pointer;\n    width: 30px;\n    height: 30px;\n\n    &:hover {\n        background: ", ";\n        transform: rotate(180deg);\n    }\n\n    b {\n        display: block;\n        position: absolute;\n        height: 0;\n        width: 0;\n        padding: 0;\n        margin: 0;\n        border: solid 15px transparent;\n\n        &:nth-child(1) {\n            border-top-color: ", ";\n            top: -2px;\n        }\n\n        &:nth-child(2) {\n            border-left-color: ", ";\n            left: -2px;\n        }\n\n        &:nth-child(3) {\n            border-bottom-color: ", ";\n            bottom: -2px;\n        }\n\n        &:nth-child(4) {\n            border-right-color: ", ";\n            right: -2px;\n        }\n    }\n"])), function (props) {
  return props.theme.invertColor.normal;
}, function (props) {
  return props.theme.scheme[Variant.PRIMARY].normal;
}, function (props) {
  return props.theme.color.dark;
}, function (props) {
  return props.theme.color.dark;
}, function (props) {
  return props.theme.color.dark;
}, function (props) {
  return props.theme.color.dark;
});
var MegaMenu = function MegaMenu(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose;
      _ref.emptyMessage;
      var menus = _ref.menus,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["open", "onClose", "emptyMessage", "menus", "title"]);

  return open && /*#__PURE__*/jsxRuntime.jsxs(Wrapper$1, _objectSpread2(_objectSpread2({}, props), {}, {
    children: [/*#__PURE__*/jsxRuntime.jsxs(TopBar, {
      children: [/*#__PURE__*/jsxRuntime.jsx(GrowElement, {
        children: title
      }), /*#__PURE__*/jsxRuntime.jsxs(CloseButton, {
        onClick: onClose,
        children: [/*#__PURE__*/jsxRuntime.jsx("b", {}), /*#__PURE__*/jsxRuntime.jsx("b", {}), /*#__PURE__*/jsxRuntime.jsx("b", {}), /*#__PURE__*/jsxRuntime.jsx("b", {})]
      })]
    }), /*#__PURE__*/jsxRuntime.jsx(Content$1, {
      children: menus.map(function (menu, index) {
        return /*#__PURE__*/jsxRuntime.jsx("div", {
          children: menu
        }, index);
      })
    })]
  }));
};
MegaMenu.propTypes = {
  open: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
  emptyMessage: propTypes.string,
  menus: propTypes.oneOfType([propTypes.arrayOf(propTypes.instanceOf(Menu)), propTypes.any]),
  top: propTypes.string
};
MegaMenu.defaultProps = {
  open: false,
  menus: [],
  emptyMessage: "Menu is empty",
  top: "0"
};

var _templateObject$8, _templateObject2$5, _templateObject3$2, _templateObject4$1;
var Wrapper = styled.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n    background-color: transparent;\n    color: ", ";\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    border-radius: ", ";\n    padding: ", ";\n    transition: all 0.3s linear;\n\n    &:hover {\n        background-color: ", ";\n        cursor: pointer;\n\n        svg {\n            height: 80px;\n            width: 80px;\n            transition: all 0.3s linear;\n        }\n    }\n"])), function (props) {
  return props.theme.invertColor.normal;
}, space(3), space(2), function (props) {
  return props.theme.scheme[Variant.PRIMARY].normal;
});
var Icon$1 = styled.div(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n    display: grid;\n    align-items: center;\n    justify-items: center;\n    transition: all 0.3s linear;\n    color: ", ";\n    height: 100px;\n    width: 100px;\n\n    > svg {\n        height: 60px;\n        width: 60px;\n        transition: all 0.3s linear;\n    }\n"])), function (props) {
  return props.theme.invertColor.normal;
});
var Title = styled.p(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n    font-weight: bold;\n    margin: ", " 0 0 0;\n"])), space(2));
var Subtitle = styled.p(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n    font-weight: lighter;\n    margin: 0 0 ", ";\n"])), space(2));
var MenuIcon = function MenuIcon(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      subtitle = _ref.subtitle,
      onClick = _ref.onClick;
  return /*#__PURE__*/jsxRuntime.jsxs(Wrapper, {
    onClick: onClick,
    children: [/*#__PURE__*/jsxRuntime.jsx(Icon$1, {
      children: icon
    }), /*#__PURE__*/jsxRuntime.jsx(Title, {
      children: title
    }), /*#__PURE__*/jsxRuntime.jsx(Subtitle, {
      children: subtitle
    })]
  });
};
MenuIcon.propTypes = {
  icon: propTypes.node,
  title: propTypes.string.isRequired,
  subtitle: propTypes.string,
  onClick: propTypes.func
};

var _templateObject$7, _templateObject2$4;
var Container$1 = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n    padding: ", ";\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    transition: background-color 0.3s linear;\n    color: ", ";\n\n    &:hover {\n        background-color: ", ";\n        transition: background-color 0.3s linear;\n    }\n"])), space(3), function (props) {
  return props.theme.invertColor.normal;
}, function (props) {
  return props.theme.scheme[props.variant].normal;
});
var IconContainer$1 = styled.div(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n    height: 1.2rem;\n    width: 1.2rem;\n    margin-right: ", ";\n"])), space(3));
var MenuItem = function MenuItem(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      variant = _ref.variant,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["icon", "label", "variant", "children"]);

  return /*#__PURE__*/jsxRuntime.jsxs(Container$1, _objectSpread2(_objectSpread2({
    variant: variant
  }, props), {}, {
    children: [icon && /*#__PURE__*/jsxRuntime.jsx(IconContainer$1, {
      children: icon
    }), label, /*#__PURE__*/jsxRuntime.jsx("span", {
      children: children
    })]
  }));
};
MenuItem.propTypes = {
  // icon: PropTypes.element,
  label: propTypes.string.isRequired,
  // items: PropTypes.arrayOf(MenuItem),
  onClick: propTypes.func,
  variant: propTypes.string
};
MenuItem.defaultProps = {
  label: "",
  variant: Variant.PRIMARY
};

var _templateObject$6, _templateObject2$3, _templateObject3$1, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
var DropDown = styled.nav(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n    position: relative;\n    display: inline-block;\n"])));
var DropDownButton = styled(Button)(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    box-shadow: none;\n    height: ", ";\n    border-radius: 0;\n    color: ", ";\n    margin: 0 ", ";\n    display: flex;\n    align-items: center;\n    transition: background-color 0.3s linear;\n    width: auto;\n\n    &:hover {\n        background-color: ", ";\n        transition: background-color 0.3s linear;\n    }\n"])), function (props) {
  return props.open ? props.theme.scheme.primary.normal : "transparent";
}, function (props) {
  return props.theme.components.topBar.height;
}, function (props) {
  return props.theme.invertColor.normal;
}, space(2), function (props) {
  return props.theme.scheme.primary.normal;
});
var Arrow = styled.i(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n    border: solid ", ";\n    border-width: 0 2px 2px 0;\n    display: inline-block;\n    padding: 3px;\n    margin-left: ", ";\n"])), function (props) {
  return props.theme.invertColor.normal;
}, space(2));
var UpArrow = styled(Arrow)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    transform: rotate(-135deg);\n    -webkit-transform: rotate(-135deg);\n    margin-bottom: -2px;\n"])));
var DownArrow = styled(Arrow)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    transform: rotate(45deg);\n    -webkit-transform: rotate(45deg);\n    margin-bottom: 2px;\n"])));
var Content = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: ", ";\n    flex-direction: column;\n    position: absolute;\n    background-color: ", ";\n    box-shadow: ", ";\n    z-index: 1;\n    color: ", ";\n    left: -12px;\n    width: 200px;\n"])), function (props) {
  return props.open ? "flex" : "none";
}, function (props) {
  return props.theme.color.normal;
}, function (props) {
  return props.theme.variables.shadow.normal;
}, function (props) {
  return props.theme.invertColor.normal;
});
var IconContainer = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    > svg {\n        height: 20px;\n        width: 20px;\n    }\n"])));
var ButtonLabel = styled.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    margin: 0 ", ";\n"])), space(2));
styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    line-height: 1.1rem;\n    padding: ", " ", ";\n    &:hover {\n        cursor: pointer;\n        background-color: ", ";\n        color: ", ";\n        transition: all 0.2s linear;\n    }\n"])), space(2), space(3), function (props) {
  return props.theme.scheme[Variant.PRIMARY].normal;
}, function (props) {
  return props.theme.scheme[Variant.PRIMARY].color;
});
function DropDownMenu(_ref) {
  var label = _ref.label,
      items = _ref.items,
      icon = _ref.icon;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      opened = _useState2[0],
      setOpened = _useState2[1];

  return /*#__PURE__*/jsxRuntime.jsxs(DropDown, {
    children: [/*#__PURE__*/jsxRuntime.jsxs(DropDownButton, {
      open: opened,
      onMouseEnter: function onMouseEnter() {
        return setOpened(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setOpened(false);
      },
      children: [icon && /*#__PURE__*/jsxRuntime.jsx(IconContainer, {
        children: icon
      }), /*#__PURE__*/jsxRuntime.jsx(ButtonLabel, {
        children: label
      }), /*#__PURE__*/jsxRuntime.jsx("span", {
        children: opened ? /*#__PURE__*/jsxRuntime.jsx(UpArrow, {}) : /*#__PURE__*/jsxRuntime.jsx(DownArrow, {})
      })]
    }), /*#__PURE__*/jsxRuntime.jsx(Content, {
      open: opened,
      onMouseEnter: function onMouseEnter() {
        return setOpened(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setOpened(false);
      },
      children: items && items.map(function (item, index) {
        return /*#__PURE__*/jsxRuntime.jsx("div", {
          children: item
        }, index);
      })
    })]
  });
}
DropDownMenu.propTypes = {
  icon: propTypes.element,
  label: propTypes.string.isRequired,
  items: propTypes.arrayOf(MenuItem).isRequired
};
DropDownMenu.defaultProps = {
  label: "Please define a label name",
  items: [/*#__PURE__*/jsxRuntime.jsx(MenuItem, {
    onClick: undefined,
    children: "Please define a label name"
  }), /*#__PURE__*/jsxRuntime.jsx(MenuItem, {
    onClick: undefined,
    children: "Please define a label name"
  }), /*#__PURE__*/jsxRuntime.jsx(MenuItem, {
    onClick: undefined,
    children: "Please define a label name"
  })]
};

var _templateObject$5, _templateObject2$2, _templateObject3;
var SnackBarStyled = styled.li(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n    position: relative;\n    display: block;\n    opacity: 0;\n    background-color: ", ";\n    color: ", ";\n    border-radius: ", ";\n    box-shadow: ", ";\n    padding: ", ";\n    margin: ", ";\n    list-style: none;\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 480px;\n    animation-name: fadeIn;\n    animation-duration: 0.5s;\n    animation-fill-mode: both;\n\n    @keyframes fadeIn {\n        from {\n            opacity: 0;\n            transform: translateX(-20px);\n        }\n        to {\n            opacity: 1;\n            transform: translateX(0);\n        }\n    }\n"])), function (props) {
  return props.theme.scheme[props.variant].normal;
}, function (props) {
  return props.theme.scheme[props.variant].color;
}, function (props) {
  return props.theme.variables.borderRadius;
}, function (props) {
  return props.theme.variables.shadow.normal;
}, space(3), space(1));
var Icon = styled.i(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n    color: ", ";\n    margin-right: ", ";\n    margin-bottom: 2px;\n\n    > svg {\n        height: 20px;\n        width: 20px;\n    }\n"])), function (props) {
  return props.theme.scheme[props.variant].color;
}, space(2));
var Message = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-right: ", ";\n    margin-left: ", ";\n"])), space(3), space(1));

var SnackBar = function SnackBar(_ref) {
  var notification = _ref.notification,
      onClose = _ref.onClose;
  var icons = useContext(IconContext);
  return /*#__PURE__*/jsxRuntime.jsx(SnackBarStyled, _objectSpread2(_objectSpread2({}, notification), {}, {
    children: /*#__PURE__*/jsxRuntime.jsxs(Flex, {
      children: [/*#__PURE__*/jsxRuntime.jsx(Icon, {
        variant: notification.variant,
        children: icons[notification.variant]
      }), /*#__PURE__*/jsxRuntime.jsx(Message, {
        children: notification.message
      }), /*#__PURE__*/jsxRuntime.jsx(CloseButton$1, {
        variant: notification.variant,
        onClick: onClose,
        children: icons.close
      })]
    })
  }));
};

SnackBar.propTypes = {
  notification: propTypes.object.isRequired
};

var _templateObject$4;
var SnackBarContext = /*#__PURE__*/createContext();
var SnackBarConsumer = styled.ul(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n    position: absolute;\n    bottom: ", ";\n    right: ", ";\n    left: ", ";\n    top: ", ";\n    padding: ", ";\n"])), function (props) {
  return props.bottom && 0;
}, function (props) {
  return props.center ? 0 : props.right && 0;
}, function (props) {
  return props.center ? 0 : props.left && 0;
}, function (props) {
  return props.top && 0;
}, space(2));

var SnackBarProvider = function SnackBarProvider(_ref) {
  var duration = _ref.duration,
      children = _ref.children,
      displayElements = _ref.displayElements,
      props = _objectWithoutProperties(_ref, ["duration", "children", "displayElements"]);

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      notifications = _useState2[0],
      setNotifications = _useState2[1];

  var notificationIds = notifications.join(',');
  var uid = 0;
  useEffect(function () {
    if (notificationIds.length > 0) {
      var timer = setTimeout(function () {
        return setNotifications(function (notifications) {
          return notifications.slice(0, notifications.length - 1);
        });
      }, duration);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [notificationIds]);
  var addNotification = useCallback(function (message, variant) {
    setNotifications(function (notifications) {
      return [{
        id: uid,
        message: message,
        variant: variant ? variant : Variant.PRIMARY
      }].concat(_toConsumableArray(notifications));
    });
    uid++;
  }, []);
  var value = useMemo(function () {
    return addNotification;
  }, [addNotification]);

  var handleOnClose = function handleOnClose(notificationId) {
    setNotifications(notifications.filter(function (not) {
      return not.id !== notificationId;
    }));
  };

  return /*#__PURE__*/jsxRuntime.jsxs(SnackBarContext.Provider, {
    value: value,
    children: [children, /*#__PURE__*/jsxRuntime.jsx(SnackBarConsumer, _objectSpread2(_objectSpread2({}, props), {}, {
      children: notifications.slice(Math.max(notifications.length - displayElements, 0)).map(function (notification) {
        return /*#__PURE__*/jsxRuntime.jsx(SnackBar, {
          notification: notification,
          onClose: function onClose() {
            return handleOnClose(notification.id);
          }
        }, notification.id);
      })
    }))]
  });
};

SnackBarProvider.propTypes = {
  duration: propTypes.number,
  left: propTypes.bool,
  right: propTypes.bool,
  top: propTypes.bool,
  bottom: propTypes.bool,
  center: propTypes.bool,
  displayElements: propTypes.number.isRequired
};
SnackBarProvider.defaultProps = {
  duration: 5000,
  displayElements: 5
};

var useSnackBar = function useSnackBar() {
  return useContext(SnackBarContext);
};

var _templateObject$3, _templateObject2$1;
var VoteCellState = {
  ABS: "ABS",
  AWAY: "AWAY",
  YES: "YES",
  NO: "NO",
  WAIT: "WAIT"
};
var Label = styled.label(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n    font-size: 1.4rem;\n    font-weight: 500;\n"])));
var Container = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n    display: grid;\n    align-items: center;\n    justify-items: center;\n    transition: all 0.3s linear;\n    height: ", ";\n    width: ", ";\n\n    &.wait, &.abs, &.yes, &.no, &.hidden, &.away {\n        transition: all 0.3s linear;\n    }\n\n    &.wait, &.abs, &.yes, &.no {\n        opacity: 1;\n    }\n\n    &.wait {\n        background-color: ", ";\n        color: ", ";\n    }\n\n    &.mandate {\n        background-color: ", ";\n        color: ", ";\n    }\n\n    &.abs {\n        background-color: ", ";\n        color: ", ";\n    }\n\n    &.yes {\n        background-color: ", ";\n        color: ", ";\n    }\n\n    &.no {\n        background-color: ", ";\n        color: ", ";\n    }\n\n    &.away {\n        background-color: ", ";\n        color: ", ";\n        opacity: 0.2;\n    }\n\n    &.hidden {\n        background-color: ", ";\n        color: ", ";\n\n        &:not(.wait), &.away {\n            opacity: 0.2;\n            color: ", ";\n        }\n    }\n"])), function (props) {
  return props.cellHeight || props.cellHeight > 0 ? props.cellHeight + "px" : "100%";
}, function (props) {
  return props.cellWidth || props.cellWidth > 0 ? props.cellWidth + "px" : "100%";
}, function (props) {
  return props.theme.scheme[Variant.LIGHT].light;
}, function (props) {
  return props.theme.scheme[Variant.LIGHT].color;
}, function (props) {
  return props.theme.scheme[Variant.SYSTEM].normal;
}, function (props) {
  return props.theme.scheme[Variant.SYSTEM].color;
}, function (props) {
  return props.theme.scheme[Variant.WARNING].normal;
}, function (props) {
  return props.theme.scheme[Variant.WARNING].color;
}, function (props) {
  return props.theme.scheme[Variant.SUCCESS].normal;
}, function (props) {
  return props.theme.scheme[Variant.SUCCESS].color;
}, function (props) {
  return props.theme.scheme[Variant.DANGER].normal;
}, function (props) {
  return props.theme.scheme[Variant.DANGER].color;
}, function (props) {
  return props.theme.scheme[Variant.ALERT].normal;
}, function (props) {
  return props.theme.scheme[Variant.ALERT].color;
}, function (props) {
  return props.theme.scheme[Variant.LIGHT].normal;
}, function (props) {
  return props.theme.scheme[Variant.LIGHT].color;
}, function (props) {
  return props.theme.scheme[Variant.LIGHT].dark;
});

var VoteCell = function VoteCell(_ref) {
  var label = _ref.label,
      props = _objectWithoutProperties(_ref, ["label"]);

  console.log(label, props.state);
  var clx = "".concat(props.state.toLowerCase(), " ").concat(props.voteHidden ? "hidden" : "");
  return /*#__PURE__*/jsxRuntime.jsx(Container, _objectSpread2(_objectSpread2({
    className: clx
  }, props), {}, {
    children: /*#__PURE__*/jsxRuntime.jsx(Label, {
      children: label
    })
  }));
};

VoteCell.propTypes = {
  state: propTypes.string.isRequired,
  voteHidden: propTypes.bool,
  cellHeight: propTypes.number,
  cellWidth: propTypes.number
};

var _templateObject$2;
var VoteGrid = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n    display: grid;\n    grid-template-columns: repeat(", ", auto);\n    grid-template-rows: repeat(", ", auto);\n    gap: ", " ", ";\n    justify-content: ", ";\n    align-content: ", ";\n    height: 100%;\n    width: 100%;\n    grid-auto-flow: column;\n"])), function (props) {
  return props.columns;
}, function (props) {
  return props.rows;
}, space(4), space(2), function (props) {
  return props.fullResponsive ? "stretch" : "center";
}, function (props) {
  return props.fullResponsive ? "stretch" : "center";
});
VoteGrid.propTypes = {
  fullResponsive: propTypes.bool
};
VoteGrid.defaultTypes = {
  fullResponsive: true
};

var _templateObject$1;
var VoteBlock = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n    display: grid;\n    grid-row-gap: ", ";\n"])), space(1));
VoteBlock.propTypes = {};

var _templateObject, _templateObject2;
var Tabs = styled.nav(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n    display: grid;\n    grid-template-columns: repeat(", ", 1fr);\n    justify-items: center;\n    background-color: ", ";\n"])), function (props) {
  return props.children.length;
}, function (props) {
  return props.theme.color.normal;
});
var Tab = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    background-color: ", ";\n    border: none;\n    width: 100%;\n    padding: ", ";\n    color: ", ";\n    transition: all 0.2s linear;\n\n    &.selected {\n        background-color: ", ";\n\n        > svg {\n            color: ", ";\n            transition: all 0.2s linear;\n        }\n    }\n\n    &:hover {\n        cursor: ", ";\n        background-color: ", ";\n\n        > svg {\n            color: ", ";\n            transition: all 0.2s linear;\n        }\n    }\n\n    > svg {\n        transition: all 0.2s linear;\n        color: ", ";\n        height: 32px;\n        width: 32px;\n        margin-right: ", ";\n    }\n"])), function (props) {
  return props.disabled ? props.theme.color.light : props.theme.color.normal;
}, space(2), function (props) {
  return props.theme.scheme[props.variant].color;
}, function (props) {
  return props.theme.scheme[Variant.PRIMARY].normal;
}, function (props) {
  return props.theme.scheme[Variant.PRIMARY].color;
}, function (props) {
  return props.disabled ? "normal" : "pointer";
}, function (props) {
  return !props.disabled && props.theme.scheme[props.variant].normal;
}, function (props) {
  return props.disabled ? props.theme.color.color : props.theme.scheme[props.variant].color;
}, function (props) {
  return props.disabled ? props.theme.color.color : props.theme.scheme[props.variant].normal;
}, space(2));
Tab.propTypes = {
  variant: propTypes.oneOfType([propTypes.oneOf([Variant]), propTypes.string])
};
Tab.defaultProps = {
  variant: Variant.PRIMARY
};

var toMoneyFormat = function toMoneyFormat(str) {
  return new Intl.NumberFormat('fr-BE', {
    style: 'currency',
    currency: 'EUR'
  }).format(str);
};
var toNumber = function toNumber(str) {
  return new Intl.NumberFormat('fr-BE', {
    minimumFractionDigits: 2
  }).format(str);
};

function removeItemAtIndex(arr, index) {
  return [].concat(_toConsumableArray(arr.slice(0, index)), _toConsumableArray(arr.slice(index + 1)));
}
function replaceItemAtIndex(arr, index, newValue) {
  return [].concat(_toConsumableArray(arr.slice(0, index)), [newValue], _toConsumableArray(arr.slice(index + 1)));
}

var PrivateRoute = function PrivateRoute(_ref) {
  var Component = _ref.component,
      authenticated = _ref.authenticated,
      rest = _objectWithoutProperties(_ref, ["component", "authenticated"]);

  return /*#__PURE__*/jsxRuntime.jsx(Route, _objectSpread2(_objectSpread2({}, rest), {}, {
    render: function render(props) {
      return authenticated ? /*#__PURE__*/jsxRuntime.jsx(Component, _objectSpread2(_objectSpread2({}, rest), props)) : /*#__PURE__*/jsxRuntime.jsx(Redirect, {
        to: {
          pathname: '/login',
          state: {
            from: props.location
          }
        }
      });
    }
  }));
};

export { Alert, Button, Card, Cell, CellHead, Checkbox, CheckboxRow, CircleButton, CloseButton$1 as CloseButton, ColorSchemeContext, ColorSchemeStore, Column, Container$4 as Container, Device, DropDownMenu, Fade, Flex, GlobalStyle, Grid, GrowElement$1 as GrowElement, H1, H2, H3, H4, H5, H6, HyperLink, IconButton, IconContext, Input, Loader, Logo, MegaMenu, Menu, MenuIcon, MenuItem, MinimalButton, Modal, Pagination, PhoneInputStylised, Pin, PrivateRoute, Radio, RadioRow, RoundedButton, Row, RowHead, Section, Select, SnackBarContext, SnackBarProvider, Tab, Table, Tabs, TextArea, TextButton, ThemeContainer, ThemeContext, ThemeStore, ThemeSwitcher, Title$3 as Title, TopBar$1 as TopBar, Variant, VoteBlock, VoteCell, VoteCellState, VoteGrid, Whitespace, apiFetch, color, components, defaultColorScheme, deleteFetch, level, postFetch, putFetch, rangeLevel, removeItemAtIndex, replaceItemAtIndex, space, themes, toMoneyFormat, toNumber, uploadFetch, useApiFetch, useCtrlKeyPress, useDownloadFetch, useFetch, useIsMountedRef, useKeyPress, useLocalStorage, useOutside, useSnackBar, variables };
